import { Carousel } from 'antd';
import { forwardRef, useCallback, useEffect, useRef, useState } from 'react';
// 引入样式文件
import '../ChatContact/style.scss'; //引入animatecss配置scss文件
import {
  CarouselItem,
  CarouselItemWrapper,
  ChatBodyButtonContainer,
  ChatBodyContainer,
  ChatBodyEndContainer,
  ChatBodyInputContainer,
  ChatBodyMessageContainer,
  ChatBodyOperationContainer,
  ChatBodyWrapper,
  ChatButton,
  ChatButtonItem,
  EndButton,
  EvaluationButton,
  EvaluationIcon,
  EvaluationText,
  GuideQuestionContainer,
  GuideQuestionTitle,
  LoadingTextBox,
  VideoButton,
} from './styled';
// 引入常量文件
import { channelState, containerState, messageDateType, messageRole } from '../../constant';
// 接口
import {
  chatCsatScore,
  checkWorkingHours,
  checkWorkTime,
  createOrder,
  getAllQuestions,
  getHistorySessionDetail,
  getKnowledgeReply,
  getKnowledgeReplyStreamPython,
  getReminder,
  requestConnect,
  updateToken,
  upvoteOrDownvote,
} from '../../utils/api';
import { isImage, isVideo } from '../../utils/fileUtil';
// 引入消息组件
import ChatMessage from '../../components/chatMessage';
// 引入loading和error组件
import Spinner from '../../components/spinner';
// 引入富文本编辑器组件
import Editor from '../editor/index';
// 移动端输入框
import videoBtn from '../../assets/videoBtn.svg';
import ChatMobileInput from '../../components/chatMobileInput';
// 笑脸图标
import face from '../../assets/face.svg';
// 引入并加载connect资源
import { fetchEventSource } from '@microsoft/fetch-event-source'; //引入fetchEventSource支持ssepost请求
import 'amazon-connect-chatjs';
import CryptoJS from 'crypto-js';
import IMWebClient from '../../sdk/im.web.sdk';
import { generateTimestampString, generateUUID, getCurrentDateTime, isContentInArray } from '../../utils/utils';
import WrappedMeetingPage from '../videoChat/main';
// 知识库接口的回话ID
let sessionId = '';
let token = ''; //openApi的token
let signToken = ''; //签名
let ts = ''; //生成签名的时间
let userTime = '';
// CONNECT客户端对象
let chatSession = null;
// 终极方法
const useGetState = (initVal) => {
  const [state, setState] = useState(initVal);
  const ref = useRef(initVal);
  const setStateCopy = (newVal) => {
    ref.current = newVal;
    setState(newVal);
  };
  const getState = () => ref.current;
  return [state, setStateCopy, getState];
};
const ErrorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="60" height="61" viewBox="0 0 60 61" fill="none">
    <path
      d="M30.0293 8.01172C33.0703 8.01172 36.0176 8.60352 38.7891 9.78125C41.4668 10.9121 43.875 12.5352 45.9434 14.6035C48.0117 16.6719 49.6348 19.0801 50.7656 21.7578C51.9375 24.5293 52.5352 27.4766 52.5352 30.5176C52.5352 33.5586 51.9434 36.5059 50.7656 39.2773C49.6348 41.9551 48.0117 44.3633 45.9434 46.4316C43.875 48.5 41.4668 50.123 38.7891 51.2539C36.0176 52.4258 33.0703 53.0234 30.0293 53.0234C26.9883 53.0234 24.041 52.4199 21.2695 51.248C18.5918 50.1172 16.1836 48.4941 14.1152 46.4258C12.0469 44.3574 10.4238 41.9492 9.29297 39.2715C8.12109 36.5 7.52344 33.5527 7.52344 30.5117C7.52344 27.4707 8.11523 24.5234 9.29297 21.752C10.4238 19.0742 12.0469 16.666 14.1152 14.5977C16.1836 12.5293 18.5918 10.9063 21.2695 9.77539C24.041 8.60938 26.9883 8.01172 30.0293 8.01172ZM30.0293 4.26172C15.5332 4.26172 3.7793 16.0156 3.7793 30.5117C3.7793 45.0078 15.5332 56.7617 30.0293 56.7617C44.5254 56.7617 56.2793 45.0078 56.2793 30.5117C56.2793 16.0156 44.5254 4.26172 30.0293 4.26172Z"
      fill="#F22417"
    />
    <path
      d="M27.0996 43.7246C27.0996 44.5016 27.4083 45.2468 27.9577 45.7962C28.5071 46.3456 29.2523 46.6543 30.0293 46.6543C30.8063 46.6543 31.5515 46.3456 32.1009 45.7962C32.6503 45.2468 32.959 44.5016 32.959 43.7246C32.959 42.9476 32.6503 42.2024 32.1009 41.653C31.5515 41.1036 30.8063 40.7949 30.0293 40.7949C29.2523 40.7949 28.5071 41.1036 27.9577 41.653C27.4083 42.2024 27.0996 42.9476 27.0996 43.7246Z"
      fill="#F22417"
    />
    <path
      d="M33.7793 18.125C33.7793 16.0508 32.0977 14.3691 30.0293 14.3691C27.9609 14.3691 26.2793 16.0508 26.2793 18.1191V18.125L27.6855 35.7969C27.7148 37.0625 28.752 38.082 30.0293 38.082C31.3066 38.082 32.3379 37.0625 32.373 35.7969L33.7793 18.125Z"
      fill="#F22417"
    />
  </svg>
);
//forwardRef父组件调用子组建的方法
const ChatBody = forwardRef((props, ref) => {
  const {
    chatConfig,
    formData,
    zoomWindow,
    toggleIcon,
    setToggleIcon,
    container,
    setContainer,
    channel,
    setChannel,
    device,
    messageDataId,
    setMessageDataId,
    isHistory,
    setIsHistory,
    isChatting,
    setChatting,
    isDisconnect,
    setDisconnect,
    agentDisabled,
    setAgentDisabled,
    mobileAgentDisabled,
    setMobileAgentDisabled,
    onEndChat,
    playTipAudio,
    agentInput,
    setAgentInput,
    singleReload,
  } = props;
  // 这里定义父组建可以调用的子组建方法
  ref.current = {
    //结束对话按钮
    endChat: () => {
      handleClickEndChat();
    },
  };
  // 傀儡变量转换zoomWindow类型 true/false
  const zoomWindowStrState = zoomWindow.toString();
  // loading状态
  const [loading, setLoading] = useState(true);
  // 上传文件的进度条
  const [uploadProgress, setUploadProgress] = useState([]);
  const [uploadCancelToken, setUploadCancelToken] = useState(null);
  // 错误消息
  const [error, setError] = useState('');
  // 客户名称，获取表单中填写的名称，没有时使用默认名称
  let customerName = formData['chat_user_name'] || chatConfig.username;
  // 消息列表
  const [messageList, setMessageList] = useState([]);
  const messageListRef = useRef([]);
  // 操作区域状态,true显示满意度评价内容，false表示显示输入框内容
  const [operationState, setOperationState] = useState(isHistory);
  // 是否需要显示满意度调查
  const [evaluationState, setEvaluationState, getEvaluationState] = useGetState(false);
  // 联系id，用于接口
  const [contactId, setContactId, getContactId] = useGetState('');
  // 输入框禁用状态
  const [inputDisable, setInputDisable, getInputDisable] = useGetState(false);
  const [inStream, setInStream] = useState(false);
  const [isPageVisible, setIsPageVisible] = useState(true);
  // 判断音视频是否通话结束
  const [videoCallState, setVideoCallState] = useState(false);
  // 适用ref保存messageDataId来保证闭包内messageid引入正确
  const messageIdRef = useRef(messageDataId);
  const channelRef = useRef(channel);
  const timerRef = useRef([]); // 坐席发送消息的定时器
  const reconnectType = useRef(false);
  const [chatButtonList, setChatButtonList] = useState([]);
  // IM重连计数和状态
  const [imReconnectCount, setImReconnectCount] = useState(0);
  const maxReconnectAttempts = 3;
  const [isEndChat, setIsEndChat] = useState(false);
  const [successChatCount, setSuccessChatCount] = useState(0);
  const successChatCountRef = useRef(0);
  const imChatLaterMessageRef = useRef(null);
  const messageDataIdListRef = useRef([]);
  const isReconnectRef = useRef(false);
  const reciveMessageTime = useRef(new Date().getTime());
  const messageWaitTime = 5; //消息间隔时间
  const [fileSizeErrorModal, setFileSizeErrorModal] = useState(false);
  let ticketObj = {};
  // 循环ticketAttr
  if (Object.keys(chatConfig.ticketAttr).length !== 0) {
    for (let key in chatConfig.ticketAttr) {
      ticketObj[key] = chatConfig.ticketAttr[key]?.value?.toString();
    }
  }
  const chatAttributes = {
    chat_user_name: formData.chat_user_name || chatConfig.username,
    chat_email: formData.chat_email || chatConfig.userEmail,
    chat_phone_number: formData.chat_phone_number || '',
    chat_member_id: chatConfig.memberId,
    chat_mobile: chatConfig.userMobile,
    channelId: chatConfig.channelId,
    sessionId: sessionId,
    wait_in_line_before: chatConfig.waitInLineBefore,
    wait_in_line_later: chatConfig.waitInLineLater,
    language_code: chatConfig.language,
    extended_country: chatConfig.extendedCountry,
    ...ticketObj,
    // pre_contact_agent: "1",
    // pre_contact_agent_name: "arn:aws:connect:us-east-1:287316796928:instance/6b65f0b7-76f3-4063-bdb5-4a1b79cd300d/agent/0e5c12b3-2d54-4c4b-9f72-31cb2468b6a3",
  };

  // 获取connect令牌请求参数
  const initiateChatRequest = {
    endpoint: chatConfig.apiGateway,
    InstanceId: chatConfig.instanceId,
    ContactFlowId: chatConfig.contactFlowId,
    ParticipantDetails: { DisplayName: customerName },
    Username: customerName,
    Attributes: chatAttributes,
    SupportedMessagingContentTypes: ['text/plain', 'text/markdown'],
    region: chatConfig.region,
    ChatConnectVideoContactFlowId: chatConfig.chatConnectVideoContactFlowId,
  };

  useEffect(() => {
    getAllQuestions({ channelId: chatConfig.channelId }).then((res) => {
      setChatButtonList(res);
    });
    // 判断是否是视频容器
    if (container === containerState.VIDEO) {
      setLoading(false);
      return;
    }

    // 判断音视频是否通话结束
    if (videoCallState) {
      return;
    }
    if (messageDataId === '') {
      let msgId = generateTimestampString();
      setMessageDataId(msgId);
      messageIdRef.current = msgId;
      channelRef.current = channel;
      if (container === containerState.CHAT_WIDGET) {
        loadChatChannel(msgId);
      }
    } else {
      if (container === containerState.CHAT_WIDGET) {
        loadChatChannel(messageDataId);
      }
    }

    const handleVisibilityChange = () => {
      setIsPageVisible(!document.hidden);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      localStorage.removeItem('inProgress');
      IMWebClient.reset();
      IMWebClient.stop();
      setChatting(false);
      setDisconnect(true);
      setMessageDataId('');
      messageIdRef.current = '';
      sessionId = '';
      setAgentDisabled(chatConfig.chatOpenChannelType === '1');
      setImReconnectCount(0); // 重置重连计数器
    };
  }, []);

  useEffect(() => {
    console.log('useEffect>>messageList>>', messageList);
    if (messageList.length === 0) {
      return;
    }
    // 去掉loading时加上的消息，false
    let i = messageList.indexOf(false);
    if (messageList && i !== -1 && messageList.length !== i + 1) {
      // 发送消息
      setMessageList((preCustomerList) => {
        console.log('useEffect>>messageList>>', preCustomerList);
        const filteredList = preCustomerList.filter((item) => item !== false);
        messageListRef.current = filteredList;
        return filteredList;
      });
      return;
    }
    if (i !== -1) {
      return;
    }
    cacheMessageList(messageListRef.current);
  }, [messageList]);

  useEffect(() => {
    // console.log('messageDataId>>>', messageDataId);
    if (isHistory) {
      return;
    }
    cacheInProgress('messageDataId', messageDataId);
    messageDataIdListRef.current.push(messageDataId);
    messageIdRef.current = messageDataId;
  }, [messageDataId]);
  useEffect(() => {
    channelRef.current = channel;
    // console.log(channel, channelRef.current);
  }, [channel]);

  useEffect(async () => {
    if (isHistory || (device == 'mobile' && chatConfig.singleChat)) {
      return;
    }
    cacheInProgress('toggleIcon', toggleIcon);
    // debugger;
    let inProgress = JSON.parse(localStorage.getItem('inProgress'));
    if (inProgress.imChatSessionId && inProgress.imChatUid && !toggleIcon) {
      IMWebClient.changeStatus({
        tenantId: chatConfig.companyId,
        statusType: '0',
      });
    }
    if (inProgress.imChatSessionId && inProgress.imChatUid && toggleIcon) {
      IMWebClient.changeStatus({
        tenantId: chatConfig.companyId,
        statusType: '1',
      });
      await findMessageDataItem(chatConfig.channelId, messageIdRef.current).then((res) => {
        // console.log('hidden事件更新>>>', res);
        if (res) {
          if (res.list?.length > 0) {
            // console.log('hidden更新消息>>>', res.list);
            setMessageList(res.list);
            messageListRef.current = res.list;
          }
        }
      });
    }
  }, [toggleIcon]);
  // useEffect(() => {
  //   console.log('chatBody>>channel>', channel);
  // }, [channel]);
  // 监听uploadProgress对象的变化，更新消息的上传进度
  useEffect(() => {
    if (messageList.length === 0) {
      return;
    }
    const updatedMessages = messageList.map((message) => {
      const upload = uploadProgress.find((upload) => upload.fileName === message.fileName);
      if (upload) {
        return { ...message, uploadProgress: upload.progress };
      }
      return message;
    });
    setMessageList(updatedMessages);
    messageListRef.current = updatedMessages;
  }, [uploadProgress]);

  useEffect(() => {
    if (mobileAgentDisabled) {
      handleClickToAgent();
      setMobileAgentDisabled(false);
    }
  }, [mobileAgentDisabled]);
  // 移动端离线消息逻辑
  useEffect(() => {
    if (isHistory || device !== 'mobile' || !chatConfig.singleChat) {
      return;
    }
    const handleBeforeUnload = () => {
      const inProgress = JSON.parse(localStorage.getItem('inProgress')) || {};
      if (document.visibilityState === 'hidden') {
        const inProgress = JSON.parse(localStorage.getItem('inProgress')) || {};
        if (inProgress.imChatSessionId && inProgress.imChatUid) {
          successChatCountRef.current = 0;
          IMWebClient.changeStatus({
            tenantId: chatConfig.companyId,
            statusType: '0',
          });
        }
      } else {
        if (inProgress?.imChatSessionId && inProgress?.imChatUid) {
          successChatCountRef.current = 0;
          IMWebClient.changeStatus({
            tenantId: chatConfig.companyId,
            statusType: '1',
          });
          findMessageDataItem(chatConfig.channelId, messageIdRef.current).then((res) => {
            console.log('hidden事件更新>>>', res);
            if (res) {
              if (res.list?.length > 0) {
                console.log('hidden更新消息>>>', res.list);
                setMessageList(res.list);
                messageListRef.current = res.list;
              }
            }
          });
        }
      }
    };

    document.addEventListener('visibilitychange', handleBeforeUnload);
    document.addEventListener('pagehide', handleBeforeUnload);
    return () => {
      // if (IMWebClient.session) {
      //   // 组件卸载时也发送离线
      //   IMWebClient.stop();
      // }
      document.removeEventListener('visibilitychange', handleBeforeUnload);
      document.removeEventListener('pagehide', handleBeforeUnload);
    };
  }, []);

  /**
   *  加载聊天渠道
   */
  const loadChatChannel = async (msgId, type) => {
    // debugger;
    setLoading(false);
    // 创建'inProgress'缓存值
    cacheInProgress();
    // 判断是否是历史数据
    // console.log('loadChatChannel>>isHistory>>>', isHistory);
    if (isHistory) {
      const result = await findMessageDataItem(chatConfig.channelId, messageIdRef.current);
      if (result) {
        const targetElement = document.getElementById('messageContainer');
        const observer = new ResizeObserver(() => {});
        observer.observe(targetElement);
        setMessageList(result.list);
        messageListRef.current = result.list;
      }
      return;
    }
    let chatOpenChannelType = chatConfig.chatOpenChannelType;
    // 如果开启KNOWLEDGE和CONNECT
    // console.log('loadChatChannel>>chatOpenChannelType>>>', chatOpenChannelType);
    // console.log('loadChatChannel>>isChatting>>>', isChatting);
    // console.log('loadChatChannel>>isDisconnect>>>', isDisconnect);
    // console.log('loadChatChannel>>chatConfig.singleChat>>>', chatConfig.singleChat);
    // console.log('loadChatChannel>>channel>>>', channel);
    // console.log('loadChatChannel>>channelRef.current>>>', channelRef.current);
    if (chatOpenChannelType === '1') {
      // 如果渠道状态是KNOWLEDGE
      if (channelState.KNOWLEDGE === channelRef.current || type === channelState.KNOWLEDGE) {
        setChannel(channelState.KNOWLEDGE);
        channelRef.current = channelState.KNOWLEDGE;
        loadKnowledgeChannel(msgId);
      }
      // 如果渠道状态是CONNECT
      // else if (channelState.CONNECT === channel) {
      //   loadConnectChannel();
      // }
      // 如果渠道状态是IM-CHAT
      else if (channelState.IM_CHAT === channelRef.current || channelState.CONNECT === channelRef.current) {
        loadIMChatChannel();
      }
    }
    // 如果只开启KNOWLEDGE
    else if (chatOpenChannelType === '2') {
      loadKnowledgeChannel(msgId);
    }
    // 如果只开启CONNECT
    else if (chatOpenChannelType === '3') {
      loadIMChatChannel();
    }
    setInputDisable(false);
  };

  // ============================================================================== 基础

  /**
   * 将消息列表存储到historySession缓存值中
   * @param messageList
   */
  function cacheMessageList(messageList) {
    // debugger;
    // console.log('cacheMessageList>>messageList>>', messageList);
    // console.log(messageDataId);
    if (isReconnectRef.current) {
      messageList.forEach((item) => {
        if (typeof item === 'object') {
          item.isNotCurrentSessionData = true;
          item.isShow = true;
        }
      });
      isReconnectRef.current = false;
    }
    if (!messageIdRef.current) {
      return;
    }
    if (messageList.length === 0) {
      return;
    }

    // 只缓存当前会话的消息，过滤掉历史记录和分隔符
    const currentSessionMessages = messageList.filter((message) => {
      // 过滤掉无效消息
      if (!message || message === false) {
        return false;
      }
      // 过滤掉历史会话消息（标记为isNotCurrentSessionData的消息）
      if (message.isNotCurrentSessionData) {
        return false;
      }
      // // 过滤掉分隔符（DIVIDER类型的消息）
      // if (message.dataType === messageDateType.DIVIDER || message.isNotUse) {
      //   return false;
      // }
      return true;
    });

    if (currentSessionMessages.length === 0) {
      return;
    }
    let data = {
      messageDataId: messageIdRef.current,
      isDisconnect: false,
      list: currentSessionMessages,
      timestamp: new Date().getTime(),
    };

    let channelList = JSON.parse(localStorage.getItem('historySession')) || [];
    const foundChannel = channelList.find((cItem) => cItem.channelId === chatConfig.channelId);
    if (foundChannel) {
      const foundMessage = foundChannel.list.find((item) => item.messageDataId === messageIdRef.current);
      if (foundMessage) {
        // 更新现有消息记录，只保存当前会话的消息
        foundMessage.list = currentSessionMessages;
        foundMessage.timestamp = new Date().getTime();
      } else if (!foundMessage) {
        // 添加新的消息记录
        foundChannel.list.push({ ...data, list: [] });
      }
    } else {
      // 创建新的频道记录
      channelList.push({
        channelId: chatConfig.channelId,
        list: [data],
      });
    }

    localStorage.setItem('historySession', JSON.stringify(channelList));
  }

  /**
   * 更新'inProgress'缓存值的数据
   * @param propertyKey
   * @param value
   */
  function cacheInProgress(propertyKey, value) {
    // debugger;
    try {
      let inProgress = JSON.parse(localStorage.getItem('inProgress')) || null;
      // console.log('cacheInProgress 更新:', { propertyKey, value, inProgress });

      if (inProgress) {
        if (!propertyKey) {
          return;
        }
        inProgress[propertyKey] = value;
        localStorage.setItem('inProgress', JSON.stringify(inProgress));
        // console.log('inProgress 已更新:', inProgress);
      } else {
        let data = {
          messageDataId: messageIdRef.current,
          channel: channelState.KNOWLEDGE,
          container: containerState.CHAT_WIDGET,
          toggleIcon: toggleIcon,
        };

        // 如果有传入的属性，则设置它
        if (propertyKey && value !== undefined) {
          data[propertyKey] = value;
        }

        localStorage.setItem('inProgress', JSON.stringify(data));
        // console.log('inProgress 已创建:', data);
      }
    } catch (error) {
      // console.error('cacheInProgress 失败:', error);
    }
  }

  /**
   * 更新'historySession'缓存值中指定的属性值
   * @param {string} propertyKey 属性键名
   * @param {any} value 属性值
   */
  function cacheHistorySession(propertyKey, value) {
    // console.log('cacheHistorySession>>', propertyKey, value);
    if (!propertyKey) {
      return;
    }
    let cacheData = JSON.parse(localStorage.getItem('historySession')) || [];
    cacheData.forEach((cItem) => {
      if (cItem.channelId === chatConfig.channelId) {
        cItem.list.forEach((item) => {
          if (item.messageDataId === messageIdRef.current) {
            item[propertyKey] = value;
          }
        });
      }
    });
    localStorage.setItem('historySession', JSON.stringify(cacheData));
  }

  function getHistorySession() {
    const channelList = JSON.parse(localStorage.getItem('historySession')) || [];
    let list = [];
    channelList.forEach((cItem) => {
      if (cItem.channelId === chatConfig.channelId) {
        const item = cItem.list.find((item) => item.messageDataId === messageIdRef.current);
        if (item && item.list && item.list.length > 0) {
          let tempList = item.list;
          // console.log(tempList, 'tempList');
          if (tempList && tempList.length > 0) {
            const lastFiveItems = tempList.slice(-19);
            lastFiveItems.forEach((item1) => {
              if (item1.content && (item1.isNotUse === undefined || !item1.isNotUse)) {
                let data = { role: item1.role === 'CUSTOMER' ? 'user' : 'bot', prompt: item1.content };
                list.push(data);
              }
            });
          }
        }
      }
    });
    // 返回list的最后6条
    return list.length > 0 ? list.slice(-6) : '';
  }

  /**
   * 更新historySession和inProgress缓存值中的指定属性
   * @param {string} propertyKey 属性键名
   * @param {any} value 属性值
   */
  function updateCacheProperty(propertyKey, value) {
    if (!propertyKey) {
      return;
    }
    // 更新'inProgress'缓存值中对应的值
    cacheInProgress(propertyKey, value);
    // 更新'historySession'缓存值中对应的值
    cacheHistorySession(propertyKey, value);
  }

  /**
   * 获取历史回话消息中指定渠道指定回话消息id的数据。
   * @param channelId 渠道
   * @param messageDataId 回话消息id
   * @returns {{sessionId: *, list}|null}
   */
  async function findMessageDataItem(channelId, messageDataId) {
    // debugger;
    // console.log('findMessageDataItem>>', channelId, messageDataId);
    let historySession = JSON.parse(localStorage.getItem('historySession')) || [];
    let foundChannel = historySession.find((channel) => channel.channelId === channelId);
    let offlineMessage = [];
    if (foundChannel) {
      let foundMessage = foundChannel.list.find((message) => message.messageDataId === messageDataId);
      let foundMessageIndex = foundChannel.list.findIndex((message) => message.messageDataId === messageDataId);
      if (foundMessage) {
        let foundMessageList = foundMessage.list;
        //在这里获取网络的历史记录，来补全历史记录消息，识别当前聊天的状态，如果是im的话就获取，knowlege就不获取
        if (foundMessage?.imChatSessionId && foundMessage?.imChatUid) {
          await getHistorySessionDetail({
            companyId: chatConfig.companyId,
            imRecordId: foundMessage?.imChatSessionId || '',
            // workRecordId: foundMessage?.workOrderId || '',
            uid: foundMessage?.imChatUid || '',
          }).then((res) => {
            // debugger;
            if (res?.code == 200 && res.data?.workContentList) {
              let arr = res.data.workContentList;
              let msgArr = [];
              arr.forEach((item) => {
                if (item.replyType == 6) {
                  if (item.eventType == 'agent_join_chat' || item.eventType == 'agent_admin_join_chat') {
                    msgArr.push(
                      createMessageItem({
                        dataType: messageDateType.EVENT,
                        content: item.replyPerson + ' ' + chatConfig.joinChatMessage,
                        contentType: 'agentJoin',
                        time: item.replyMillisTime,
                        msgId: item.workRecordContentId,
                        messageAckStatus: item.messageAckStatus,
                        channel: channelState.IM_CHAT,
                      })
                    );
                  } else if (item.eventType == 'normal_message') {
                    msgArr.push(
                      createMessageItem({
                        contentType:
                          item.contentType == 1
                            ? 'markdown'
                            : item.contentType == 2
                            ? 'image'
                            : item.contentType == 5
                            ? 'video'
                            : item.contentType == 3
                            ? 'video'
                            : 'link',
                        dataType: messageDateType.EVENT,
                        content: item.content,
                        time: item.replyMillisTime,
                        msgId: item.workRecordContentId,
                        messageAckStatus: item.messageAckStatus,
                        channel: channelState.IM_CHAT,
                      })
                    );
                  } else if (item.eventType == 'transfer_agent') {
                    // msgArr.push(
                    //   createMessageItem({
                    //     dataType: messageDateType.EVENT,
                    //     content: item.replyPerson + ' ' + chatConfig.joinChatMessage,
                    //     contentType: 'agentJoin',
                    //   })
                    // );
                  } else if (item.eventType == 'message_withdraw') {
                    msgArr.push(
                      createMessageItem({
                        dataType: messageDateType.EVENT,
                        content: chatConfig.recallMsg,
                        time: item.replyMillisTime,
                        msgId: item.workRecordContentId,
                        messageAckStatus: item.messageAckStatus,
                        channel: channelState.IM_CHAT,
                      })
                    );
                  }
                } else if (item.replyType == 1 || item.replyType == 8) {
                  let obj = {};
                  if (item.dataStatus == '999') {
                    obj = {
                      dataType: messageDateType.EVENT,
                      content: chatConfig.recallMsg,
                      msgId: item.workRecordContentId,
                      channel: channelState.IM_CHAT,
                    };
                  } else {
                    obj = {
                      dataType: messageDateType.MESSAGE,
                      role: messageRole.AGENT,
                      displayName: chatConfig.botName,
                      contentType:
                        item.contentType == 1
                          ? 'markdown'
                          : item.contentType == 2
                          ? 'image'
                          : item.contentType == 5
                          ? 'video'
                          : item.contentType == 3
                          ? 'video'
                          : 'link',
                      content: item.content,
                      displayName: item.replyPerson || '',
                      fileName: item?.ticketFileList[0]?.file_name,
                      msgId: item.workRecordContentId,
                      time: item.replyMillisTime,
                      uid: res.data?.agentSessionId,
                      uploadStatus: 'none',
                      uploadProgress: 100,
                      msgId: item.workRecordContentId,
                      messageAckStatus: item.messageAckStatus,
                      channel: channelState.IM_CHAT,
                      extra: {
                        referenceMessage: {
                          referenceContent: item.referenceContent,
                          referenceContentType:
                            item.referenceContentType == 1
                              ? 'text'
                              : item.referenceContentType == 2
                              ? 'image'
                              : item.referenceContentType == 5
                              ? 'video'
                              : item.referenceContentType == 3
                              ? 'video'
                              : 'link',
                          referenceReplyPerson: item.referenceReplyPerson,
                          referenceContentFile: item.referenceContentFile,
                          referenceContentId: item.referenceWorkRecordContentId,
                        },
                      },
                    };
                  }
                  msgArr.push(createMessageItem(obj));
                } else if (item.replyType == 2) {
                  let obj = {
                    dataType: messageDateType.MESSAGE,
                    role: messageRole.CUSTOMER,
                    displayName: customerName,
                    contentType:
                      item.contentType == 1
                        ? 'markdown'
                        : item.contentType == 2
                        ? 'image'
                        : item.contentType == 5
                        ? 'video'
                        : item.contentType == 3
                        ? 'video'
                        : 'link',
                    fileName: item?.ticketFileList[0]?.file_name,
                    msgId: item.workRecordContentId,
                    content: item.content,
                    time: item.replyMillisTime,
                    uid: item.agentSessionId,
                    uploadStatus: 'none',
                    uploadProgress: 100,
                    msgId: item.workRecordContentId,
                    messageAckStatus: item.messageAckStatus,
                    channel: channelState.IM_CHAT,
                  };
                  msgArr.push(createMessageItem(obj));
                } else if (item.replyType == 3) {
                  msgArr.push(
                    createMessageItem({
                      dataType: messageDateType.MESSAGE,
                      role: messageRole.KNOWLEDGE,
                      displayName: chatConfig.botName,
                      contentType: 'text/plain',
                      content: item.content,
                      time: item.replyMillisTime,
                      msgId: item.workRecordContentId,
                      messageAckStatus: item.messageAckStatus,
                      channel: channelState.IM_CHAT,
                    })
                  );
                }
              });
              // let haveMsgidArr = foundMessageList.findIndex((item) => item.msgId == msgArr[0]?.msgId);
              let haveMsgidArr = foundMessageList.findIndex((item) => item.contentType == 'agentJoin');
              if (msgArr.findIndex((item) => item.contentType == 'agentJoin') != -1) {
                foundMessageList = foundMessageList.slice(0, haveMsgidArr);
                foundMessageList = [...foundMessageList, ...msgArr];
              }
            }
          });
        }
        foundMessageList = foundMessageList.filter((item) => item.contentType !== 'noAgent');
        let historyMessagesList = [];
        if (chatConfig.singleChat) {
          let historyCount = 3; // 默认值
          if (chatConfig.historyChatNum !== undefined && chatConfig.historyChatNum !== null) {
            const parsed = parseInt(chatConfig.historyChatNum, 10);
            if (!isNaN(parsed) && parsed >= 0) {
              historyCount = parsed;
            }
          }
          if (chatConfig.showHistoryChatFlag != '1') {
            historyCount = 0;
          }
          let historyMessages = [];
          if (foundChannel.list.length == 1) {
            historyMessages = foundChannel.list.filter((item) => item.messageDataId != foundMessage.messageDataId);
            historyMessages.forEach((item) => {
              item.list.forEach((item1) => {
                if (item1.contentType == 'noAgent') {
                  item1.isNotCurrentSessionData = true;
                  item1.isShow = true;
                }
                historyMessagesList.push({ ...item1 });
              });
            });
          } else {
            historyMessages = foundChannel.list
              .slice(-historyCount)
              .filter((item) => item.messageDataId != foundMessage.messageDataId);
            historyMessages.forEach((item) => {
              let index = messageDataIdListRef.current.findIndex((e) => item.messageDataId === e);
              console.log('findMessageDataItem>>index>>', index);
              if (index === -1) {
                item.list.forEach((item1) => {
                  if (
                    typeof item1 === 'object' &&
                    (item1.contentType == 'agentJoin' ||
                      item1.contentType == 'agentLeave' ||
                      item1.contentType == 'endChat' ||
                      // item1.contentType == 'queueCount' ||
                      (item1.contentType == 'evaluation' && item1.disabled !== true) ||
                      item1.dataType == messageDateType.MESSAGE)
                  ) {
                    historyMessagesList.push({ ...item1, isNotCurrentSessionData: true, isShow: true });
                  }
                });
              } else {
                item.list.forEach((item1) => {
                  if (item1.contentType == 'noAgent') {
                    item1.isNotCurrentSessionData = true;
                    item1.isShow = true;
                  }
                  historyMessagesList.push({ ...item1, isNotCurrentSessionData: true, isShow: true });
                });
              }
              // if (arr.length > 0) {
              //   historyMessagesList.push(
              //     createMessageItem({
              //       dataType: messageDateType.DIVIDER,
              //       content: item.list[item.list.length - 1].time,
              //       isNotCurrentSessionData: true,
              //       isNotUse: true,
              //     })
              //   );
              // }
            });
          }

          let arr = [];
          let lastShowTime = '';
          console.log('historyMessages>>', arr);
          let list = [...historyMessagesList, ...foundMessageList];
          list.forEach((item, index) => {
            let current = new Date(item.time).getTime();
            if (isNaN(current)) {
              current = new Date(item.time * 1).getTime();
            }
            if (
              lastShowTime == '' ||
              current - lastShowTime >= messageWaitTime * 60 * 1000 ||
              item.contentType === 'agentJoin'
            ) {
              lastShowTime = current;
              reciveMessageTime.current = new Date(current).getTime();
              arr.push(
                createMessageItem({
                  dataType: messageDateType.DIVIDER,
                  content: formatTime(current),
                  isNotUse: true,
                  isNotCurrentSessionData: true,
                })
              );
            }
            arr.push(item);
          });
          return {
            ...foundMessage,
            list: arr,
          };
        } else {
          let list = [];
          let lastShowTime = '';
          foundMessageList.forEach((item, index) => {
            let current = new Date(item.time).getTime();
            if (isNaN(current)) {
              current = new Date(item.time * 1).getTime();
            }
            if (
              lastShowTime == '' ||
              current - lastShowTime >= messageWaitTime * 60 * 1000 ||
              item.contentType === 'agentJoin'
            ) {
              lastShowTime = current;
              reciveMessageTime.current = new Date(current).getTime();
              list.push(
                createMessageItem({
                  dataType: messageDateType.DIVIDER,
                  content: formatTime(current),
                  isNotUse: true,
                  isNotCurrentSessionData: true,
                })
              );
            }
            list.push(item);
          });
          return { ...foundMessage, list: list };
        }
      } else {
        let historyMessagesList = [];
        if (chatConfig.singleChat) {
          let historyCount = 3; // 默认值
          if (chatConfig.historyChatNum !== undefined && chatConfig.historyChatNum !== null) {
            const parsed = parseInt(chatConfig.historyChatNum, 10);
            if (!isNaN(parsed) && parsed >= 0) {
              historyCount = parsed;
            }
          }
          if (chatConfig.showHistoryChatFlag != '1') {
            historyCount = 0;
          }
          let historyMessages = foundChannel.list.slice(-historyCount);
          // console.log('historyMessages>>', historyMessages);
          historyMessages.forEach((item) => {
            let arr = [];
            let index = messageDataIdListRef.current.findIndex((e) => item.messageDataId === e);
            // console.log('findMessageDataItem>>index>>', index);
            if (index === -1) {
              item.list.forEach((item1) => {
                if (
                  typeof item1 === 'object' &&
                  (item1.contentType == 'agentJoin' ||
                    item1.contentType == 'agentLeave' ||
                    item1.contentType == 'endChat' ||
                    // item1.contentType == 'queueCount' ||
                    (item1.contentType == 'evaluation' && item1.disabled !== true) ||
                    item1.dataType == messageDateType.MESSAGE)
                ) {
                  arr.push({ ...item1, isNotCurrentSessionData: true, isShow: true });
                }
              });
            } else {
              item.list.forEach((item1) => {
                if (item1.contentType == 'noAgent') {
                } else {
                  arr.push({ ...item1, isNotCurrentSessionData: true, isShow: true });
                }
              });
            }
            historyMessagesList.push(...arr);
            // if (arr.length > 0) {
            //   historyMessagesList.push(
            //     createMessageItem({
            //       dataType: messageDateType.DIVIDER,
            //       content: item.list[item.list.length - 1].time,
            //       isNotCurrentSessionData: true,
            //       isNotUse: true,
            //     })
            //   );
            // }
          });
          // console.log('historyMessages>>', historyMessages);
          let list = [];
          let lastShowTime = '';

          historyMessagesList.forEach((item, index) => {
            let current = new Date(item.time).getTime();
            if (isNaN(current)) {
              current = new Date(item.time * 1).getTime();
            }
            if (
              lastShowTime == '' ||
              current - lastShowTime >= messageWaitTime * 60 * 1000 ||
              item.contentType === 'agentJoin'
            ) {
              lastShowTime = current;
              reciveMessageTime.current = new Date(current).getTime();
              list.push(
                createMessageItem({
                  dataType: messageDateType.DIVIDER,
                  content: formatTime(current),
                  isNotUse: true,
                  isNotCurrentSessionData: true,
                })
              );
            }
            list.push(item);
          });
          return {
            list: list,
          };
        }
        return null;
      }
    } else {
    }
    return null;
  }

  // function findMessageDataItem(channelId, messageDataId) {
  //   console.log('findMessageDataItem 被调用，参数:', {
  //     channelId,
  //     messageDataId,
  //     'messageIdRef.current': messageIdRef.current,
  //   });

  //   try {
  //     const channelList = JSON.parse(localStorage.getItem('historySession')) || [];
  //     console.log('historySession 数据:', channelList);

  //     const foundChannel = channelList.find((channel) => channel.channelId === channelId);
  //     if (!foundChannel) {
  //       console.log('未找到对应的渠道:', channelId);
  //       return null;
  //     }

  //     const messageList = foundChannel.list || [];
  //     console.log('找到渠道，消息列表长度:', messageList.length);

  //     // 使用传入的 messageDataId 而不是 messageIdRef.current
  //     const actualMessageId = messageDataId || messageIdRef.current;
  //     console.log('实际使用的 messageDataId:', actualMessageId);

  //     const messageIndex = messageList.findIndex((message) => {
  //       console.log('比较消息ID:', message.messageDataId, '与', actualMessageId);
  //       return message.messageDataId === actualMessageId;
  //     });

  //     if (messageIndex === -1 && !chatConfig.singleChat) {
  //       console.log('未找到匹配的消息');
  //       return null;
  //     }

  //     console.log('找到消息，索引:', messageIndex);

  //     // 继续原有逻辑
  //     if (chatConfig.singleChat) {
  //       console.log('走了singleChat,开始查找历史记录', chatConfig.historyChatNum);
  //       // 修复配置解析问题

  //       let historyCount = 3; // 默认值
  //       if (chatConfig.historyChatNum !== undefined && chatConfig.historyChatNum !== null) {
  //         const parsed = parseInt(chatConfig.historyChatNum, 10);
  //         if (!isNaN(parsed) && parsed >= 0) {
  //           historyCount = parsed;
  //         }
  //       }
  //       if (chatConfig.showHistoryChatFlag != '1') {
  //         historyCount = 0;
  //       }
  //       // console.log('实际使用的历史记录数量:', historyCount);
  //       // 设置所有消息的show属性 - 保留所有event事件显示
  //       // 过滤出包含有效消息的会话，用于计算历史记录范围
  //       // 有效消息包括：非系统消息（用于计算数量），但所有消息都显示
  //       let validSessions = [];
  //       for (let i = 0; i < messageList.length; i++) {
  //         const session = messageList[i];
  //         if (session && session.list) {
  //           // 首先设置所有消息的show属性 - 所有event事件都显示
  //           session.list.forEach((message) => {
  //             if (message && message.dataType) {
  //               // 处理show属性：如果是true或false就删除，如果是对象就增加isNotCurrentSessionData和isShow
  //               if (message.show === true || message.show === false) {
  //                 delete message.show;
  //               } else if (message.show && typeof message.show === 'object') {
  //                 message.isNotCurrentSessionData = true;
  //                 message.isShow = true;
  //               } else if (message.dataType == messageDateType.EVALUATION) {
  //                 message.isNotCurrentSessionData = true;
  //                 message.isShow = true;
  //               }
  //               // 注意：这里不设置isNotCurrentSessionData，因为这是当前会话的消息
  //             }
  //           });

  //           // 检查这个会话是否包含有效消息（用于计算历史记录数量的消息：非系统消息）
  //           const hasValidMessages = session.list.some((message) => {
  //             return message && message.dataType !== messageDateType.EVENT;
  //           });

  //           if (hasValidMessages) {
  //             validSessions.push({ session, originalIndex: i });
  //             if (
  //               chatConfig.companyId === '7f7113da58b91751b7336213542d9232' ||
  //               chatConfig.companyId === '03f433505c9cdfb7d56afc32127f1d85'
  //             ) {
  //               validSessions = validSessions.filter((item) => item.session.timestamp > 1756719000000);
  //             }
  //           }
  //         }
  //       }

  //       // console.log('有效会话数量（包含非系统消息的会话）:', validSessions.length);
  //       // console.log('有效会话（包含非系统消息的会话）:', validSessions);
  //       // console.log('当前消息在原始列表中的索引:', messageIndex);

  //       // 找到当前消息在有效会话中的位置
  //       const currentValidIndex = validSessions.findIndex((item) => item.originalIndex === messageIndex);
  //       //如果是全新的消息，则默认去取最后一条之前的消息来显示
  //       if (currentValidIndex === -1) {
  //         // console.warn('当前消息不在有效会话列表中');

  //         // 如果 messageDataId 为空，说明是新会话，直接返回 null，不要加载历史记录
  //         if (!actualMessageId && chatConfig.showHistoryChatFlag != '1') {
  //           // console.log('新会话开始，不加载历史记录');
  //           return null;
  //         }

  //         // console.log('取最后一条有效会话来显示');
  //         // 如果找不到当前消息在有效会话中，则取最后一条有效会话
  //         if (validSessions.length > 0) {
  //           // debugger;
  //           let lastValidSession = validSessions[validSessions.length - 1];

  //           // console.log('使用最后一条有效会话:', lastValidSession);

  //           // 获取历史消息 - 按实际可用的历史会话数量处理
  //           // historyCount 表示要显示的历史会话数量，所以总共需要 historyCount + 1 个会话（包括当前会话）
  //           const totalNeededSessions = historyCount + 1;
  //           const actualTotalCount = Math.min(totalNeededSessions, validSessions.length);
  //           const recentValidSessions = validSessions.slice(Math.max(0, validSessions.length - actualTotalCount));
  //           const historyMessages = recentValidSessions.slice(0, -1).reduce((acc, session, index) => {
  //             if (session.session && session.session.list) {
  //               const lastMessageTime = session.session.list[session.session.list.length - 1]?.time || '';
  //               const sessionMessages = [];

  //               session.session.list.forEach((message) => {
  //                 if (message && typeof message === 'object' && message.dataType) {
  //                   // 处理show属性：如果是true或false就删除，如果是对象就增加isNotCurrentSessionData和isShow
  //                   if (message.show === true || message.show === false) {
  //                     delete message.show;
  //                     message.isNotCurrentSessionData = true;
  //                   } else if (message.show && typeof message.show === 'object') {
  //                     message.isNotCurrentSessionData = true;
  //                     message.isShow = true;
  //                   } else if (message.dataType == messageDateType.EVALUATION) {
  //                     message.isNotCurrentSessionData = true;
  //                     message.isShow = true;
  //                   } else {
  //                     // 如果没有show属性，也标记为历史消息
  //                     message.isNotCurrentSessionData = true;
  //                   }
  //                   sessionMessages.push(message);
  //                 }
  //               });

  //               if (sessionMessages.length > 0) {
  //                 acc.push(...sessionMessages);
  //                 acc.push(
  //                   createMessageItem({
  //                     dataType: messageDateType.DIVIDER,
  //                     content: lastMessageTime,
  //                     isNotCurrentSessionData: true,
  //                     isNotUse: true,
  //                   })
  //                 );
  //               }
  //             }
  //             return acc;
  //           }, []);

  //           // 如果当前会话已断开，则所有消息都标记为历史记录
  //           let currentSessionMessages = lastValidSession.session.list || [];
  //           if (lastValidSession.session.isDisconnect === true) {
  //             currentSessionMessages = currentSessionMessages.map((message) => {
  //               if (message && typeof message === 'object' && message.dataType) {
  //                 // 处理show属性：如果是true或false就删除，如果是对象就增加isNotCurrentSessionData和isShow
  //                 if (message.show === true || message.show === false) {
  //                   delete message.show;
  //                   message.isNotCurrentSessionData = true;
  //                 } else if (message.show && typeof message.show === 'object') {
  //                   message.isNotCurrentSessionData = true;
  //                   message.isShow = true;
  //                 } else {
  //                   // 如果没有show属性，也标记为历史消息
  //                   message.isNotCurrentSessionData = true;
  //                 }
  //               }
  //               return message;
  //             });
  //           }

  //           const result = {
  //             ...lastValidSession.session,
  //             list: [...historyMessages, ...currentSessionMessages],
  //           };
  //           // console.log('返回最后一条有效会话的合并结果:', JSON.stringify(result));
  //           return result;
  //         }

  //         // 如果连有效会话都没有，返回当前消息
  //         return messageList[messageIndex] || null;
  //       }

  //       // console.log('当前消息在有效会话中的索引:', currentValidIndex);

  //       // 基于有效会话计算范围 - 按实际可用的历史会话数量处理
  //       // historyCount 表示要显示的历史会话数量，当前会话不算在内
  //       const actualHistoryCount = Math.min(historyCount, currentValidIndex);
  //       // console.log(
  //       //   '配置的历史会话数量:',
  //       //   historyCount,
  //       //   '当前会话索引:',
  //       //   currentValidIndex,
  //       //   '实际历史会话数量:',
  //       //   actualHistoryCount,
  //       //   '总会话数:',
  //       //   validSessions.length
  //       // );
  //       const startValidIndex = Math.max(0, currentValidIndex - actualHistoryCount);
  //       const endValidIndex = currentValidIndex + 1;

  //       // console.log('有效会话切片范围:', { startValidIndex, endValidIndex, totalValidSessions: validSessions.length });

  //       if (startValidIndex >= endValidIndex) {
  //         // console.warn('无效的有效会话切片范围');
  //         return messageList[messageIndex] || null;
  //       }

  //       // 获取选中的有效会话
  //       const selectedValidSessions = validSessions.slice(startValidIndex, endValidIndex);
  //       // console.log('选中的有效会话数量:', selectedValidSessions.length);

  //       // 转换回原始会话数据
  //       const recentMessages = selectedValidSessions.map((item) => item.session);
  //       // console.log('获取到的最近消息数量:', recentMessages.length);
  //       const historyMessages = recentMessages.reduce((acc, session, index) => {
  //         // 只处理历史会话（不包括当前会话）
  //         if (index < recentMessages.length - 1 && session && session.list) {
  //           const lastMessageTime = session.list[session.list.length - 1]?.time || '';
  //           const sessionMessages = []; // 临时存储当前会话的消息

  //           // Mark all messages in this session as not current
  //           session.list.forEach((message) => {
  //             if (message && typeof message === 'object' && message.dataType) {
  //               // console.log('处理历史消息>>', message.dataType, message.contentType, 'show:', message.show);
  //               // 处理show属性：如果是true或false就删除，如果是对象就增加isNotCurrentSessionData和isShow
  //               if (message.show === true || message.show === false) {
  //                 delete message.show;
  //                 message.isNotCurrentSessionData = true;
  //               } else if (message.show && typeof message.show === 'object') {
  //                 message.isNotCurrentSessionData = true;
  //                 message.isShow = true;
  //               } else {
  //                 // 如果没有show属性，也标记为历史消息
  //                 message.isNotCurrentSessionData = true;
  //               }
  //               sessionMessages.push(message);
  //             }
  //           });

  //           // 只有当这个会话真的有消息时，才添加消息和分隔符
  //           if (sessionMessages.length > 0) {
  //             // console.log(`会话 ${index} 有 ${sessionMessages.length} 条消息，添加分隔符`, sessionMessages);
  //             // 先添加这个会话的所有消息
  //             acc.push(...sessionMessages);
  //             // 再添加分隔符
  //             acc.push(
  //               createMessageItem({
  //                 dataType: messageDateType.DIVIDER,
  //                 content: lastMessageTime,
  //                 isNotCurrentSessionData: true,
  //                 isNotUse: true,
  //               })
  //             );
  //           } else {
  //             // console.log(`会话 ${index} 没有有效消息，跳过分隔符`);
  //           }
  //         }
  //         return acc;
  //       }, []);

  //       // console.log('处理后的历史消息数量:', historyMessages.length);
  //       // console.log('historyMessages', historyMessages);
  //       let obj = JSON.stringify(historyMessages);
  //       // 获取当前会话数据
  //       const currentMessageData = recentMessages[recentMessages.length - 1];
  //       // console.log('currentMessageData', currentMessageData);
  //       if (!currentMessageData) {
  //         // console.warn('未找到当前会话数据');
  //         return null;
  //       }

  //       // 如果当前会话已断开，则所有消息都标记为历史记录
  //       let currentSessionMessages = currentMessageData.list || [];
  //       if (currentMessageData.isDisconnect === true) {
  //         currentSessionMessages = currentSessionMessages.map((message) => {
  //           if (message && typeof message === 'object' && message.dataType) {
  //             // 处理show属性：如果是true或false就删除，如果是对象就增加isNotCurrentSessionData和isShow
  //             if (message.show === true || message.show === false) {
  //               delete message.show;
  //               message.isNotCurrentSessionData = true;
  //             } else if (message.show && typeof message.show === 'object') {
  //               message.isNotCurrentSessionData = true;
  //               message.isShow = true;
  //             } else {
  //               // 如果没有show属性，也标记为历史消息
  //               message.isNotCurrentSessionData = true;
  //             }
  //           }
  //           return message;
  //         });
  //       }

  //       const result = { ...currentMessageData, list: [...JSON.parse(obj), ...currentSessionMessages] };
  //       // console.log('最终合并的消息数量:', result.list.length);
  //       // console.log('最终合并的消息:', result);
  //       return result;
  //     }
  //     // If showHistoryChatFlag is not enabled, return the specific message data directly
  //     return messageList[messageIndex] || null;
  //   } catch (error) {
  //     // console.error('findMessageDataItem 解析数据失败:', error);
  //     return null;
  //   }
  // }

  /**
   * 创建消息体数据
   * @param messageData
   * @returns {{fileName, role, displayName, dataType: (string|string|*), list, contentType, content}}
   */
  function createMessageItem(messageData) {
    return {
      // 消息类型
      dataType: messageData.dataType || '', // 消息角色
      role: messageData.role || '', // 名称
      displayName: messageData.displayName || '', // 内容类型
      contentType: messageData.contentType || '', // 消息内容
      content: messageData.content || '', // 推荐消息列表
      list: messageData.list || [], // 文件名称，用于类型为Link时使用属性显示
      fileName: messageData.fileName || '',
      ...messageData,
    };
  }

  /**
   * 添加消息
   * @param message
   */
  function addMessageItem(message) {
    if (message.content !== undefined && message.content !== null && message.content !== '') {
      message.time = getCurrentDateTime();
      message.chatUserName = customerName;
      message.chatEmail = formData['chat_email'];
      message.chatPhoneNumber = formData['chat_phone_number'];
      message.channel = channel;
    }
    // if (message.contentType === 'queueCount') {
    //   console.log('queueCount', message);
    //   setMessageList((preCustomerList) => {
    //     console.log('queueCount>>preCustomerList', preCustomerList);
    //     let message1 = preCustomerList.find(
    //       (item) => item?.contentType == 'queueCount' && item?.sessionId == message?.sessionId
    //     );
    //     console.log('message1>>>', message1);
    //     console.log('message.sessionId>>>', message.sessionId);
    //     return [...preCustomerList, message];
    //   });
    // } else {
    setMessageList((preCustomerList) => {
      const newList = [...preCustomerList, message];
      messageListRef.current = newList;
      return newList;
    });
    // }
    updateMessageScrollBarInfo();
  }

  /**
   * 添加评分消息
   */
  async function addEvaluationItem(messageId, sessionId, imChatUid) {
    // 如果是connect
    if (channel === channelState.CONNECT) {
      // 是否存在评分数据。
      let isExist = null;
      await setMessageList((pre) => {
        isExist = pre.find((item) => item.dataType === messageDateType.EVALUATION);
        messageListRef.current = pre;
        return pre;
      });
      if (isExist) {
        setEvaluationState(false); // 底部不显示笑脸和邀请评分文案
        return;
      }
    }

    // 判断是否开启邀请功能
    let evaluationStateTemp = getEvaluationState();
    if (evaluationStateTemp && chatConfig.chatSatisfactionEvaluationFlag === '1') {
      let res = await findMessageDataItem(chatConfig.channelId, messageIdRef.current);
      const message = createMessageItem({
        dataType: messageDateType.EVALUATION,
        displayName: chatConfig.botName,
        content: 0,
        disabled: false,
        contentType: 'evaluation',
        workRecordId: sessionId,
        messageDataId: messageId,
        imChatUid: imChatUid,
      });
      addMessageItem(message);
    }
  }

  /**
   * 添加event类型消息
   * @param content
   */
  function addEventItem(content, type) {
    if (!content) return;
    let message = null;
    if (type) {
      message = createMessageItem({ dataType: messageDateType.EVENT, content: content, contentType: type });
    } else {
      message = createMessageItem({ dataType: messageDateType.EVENT, content: content });
    }
    addMessageItem(message);
  }

  /**
   * 滚动消息
   */
  function updateMessageScrollBarInfo() {
    setTimeout(function () {
      let div = document.getElementById('messageContainer');
      // 始终将滚动条置底
      if (div) {
        div.scrollTop = div?.scrollHeight;
      }
    }, 200);
  }

  const updateMessageById = (messageId) => {
    // 先删
    setMessageList((prevMessageList) => {
      // 返回更新后的消息列表
      let list = prevMessageList.filter((message) => message.messageId !== messageId);
      messageListRef.current = list;
      return list;
    });
  };

  const handleClickToAgent = async (isNotUse = true) => {
    setInputDisable(true);
    addMessageItem(false);
    // 清楚sendDelayMessage中
    timerRef.current.forEach((timer) => clearTimeout(timer));
    timerRef.current = [];
    // 德业公司需求非工作时间不转人工
    if (
      chatConfig.companyId === '7f7113da58b91751b7336213542d9232' ||
      chatConfig.companyId === '03f433505c9cdfb7d56afc32127f1d85'
    ) {
      let r = await checkWorkingHoursFunc();
      if (!r) {
        // 如果不再工作时间发送一条非工作时间的系统消息。
        addEventItem(chatConfig.nonWorkingHours);
        setInputDisable(false);
      } else if (chatConfig.openSelfChat === '1') {
        loadIMChatChannel();
      }
    } else {
      //除德业外所有人工时间处理
      let form = JSON.parse(localStorage.getItem('goclouds-chat-form'));
      let userName = (form ? form.username : '') || chatConfig.username;
      let phoneNumber = (form ? form.phoneNumber : '') || '';
      let params = {
        channelId: chatConfig.channelId,
        chatUserName: userName,
        ticketId: sessionId,
        customerContactInfo: phoneNumber,
      };
      params = sortObjectKeysLexicographically(params);
      let ts = new Date().getTime();
      let sign =
        'client_id=' +
        process.env.CLIENT_ID +
        '&ts=' +
        ts +
        '&body=' +
        JSON.stringify(params) +
        '&client_secret=' +
        process.env.SECURITY_KEY;
      let header = {
        ts: ts,
        sign: CryptoJS.MD5(sign.toLocaleLowerCase()).toString(CryptoJS.enc.Hex),
      };
      checkWorkTime(params, header).then((res) => {
        addMessageItem(true);
        if (res?.code == 200 && chatConfig.openSelfChat === '1' && res?.data == 1) {
          loadIMChatChannel();
        } else if (res?.code == 200 && res?.data == 0) {
          addEventItem(chatConfig.notWorkTime);
          setInputDisable(false);
        } else {
          console.log('没有人工渠道');
        }
      });
    }
  };

  // ============================================================================== 机器人

  /**
   * 加载机器人渠道
   */
  async function loadKnowledgeChannel(msgId) {
    // debugger;
    console.log('loadKnowledgeChannel>>调用了');
    // 是否是进行中的回话 或 是否需要重新创建回话
    if (isChatting || !isDisconnect) {
      //正在聊天or未断开连接，获取历史消息
      const result = await findMessageDataItem(chatConfig.channelId, messageIdRef.current);
      if (result) {
        console.log('123456>>result.list', result.list);
        setMessageList(result.list);
        messageListRef.current = result.list;
        sessionId = result.workOrderId;
        updateCacheProperty('workOrderId', result.workOrderId);
      }
      return;
    }

    // 欢迎语状态字段，1表示获取后台知识库中的欢迎语，不等于1表示使用配置项中的欢迎语。
    let openKnowledgeWelcome = chatConfig.openKnowledgeWelcome;
    // 如果开启了根据问题id获取欢迎语
    if (openKnowledgeWelcome === '1') {
      getKnowledgeMessage('1', chatConfig.knowledgeWelcomeQId, true);
    } else {
      addMessageItem(
        createMessageItem({
          dataType: messageDateType.DIVIDER,
          content: formatTime(new Date().getTime()),
          isNotUse: true,
          isNotCurrentSessionData: true,
        })
      );
      let message = createMessageItem({
        dataType: messageDateType.MESSAGE,
        role: messageRole.KNOWLEDGE,
        displayName: chatConfig.botName,
        contentType: 'text/plain',
        content: chatConfig.chatWelcomeContent,
      });
      console.log('添加了欢迎语>>>', message);
      addMessageItem(message);
    }

    if (chatConfig.singleChat) {
      setTimeout(async () => {
        const result = await findMessageDataItem(chatConfig.channelId, messageIdRef.current);
        if (result) {
          setMessageList(result.list);
          messageListRef.current = result.list;
        }
        setTimeout(() => {
          if (imChatLaterMessageRef.current != null) {
            sendMessage(imChatLaterMessageRef.current.content);
            imChatLaterMessageRef.current = null;
          }
        }, 1000);
      }, 0);
    }

    // setTimeout(function () {
    //   // 如果开启了历史记录
    //   // if (chatConfig.showHistoryChatFlag === "1") {
    //   if (chatConfig.singleChat) {
    //     const result = findMessageDataItem(chatConfig.channelId, msgId);

    //     if (result) {
    //       console.log(`[setMessageList] Line 998: Setting messageList to:`, JSON.stringify(result.list, null, 2));
    //       setMessageList(result.list);
    //       messageListRef.current = result.list;
    //     }
    //   }
    // }, 300);
    setInputDisable(false);
  }

  /**
   * 获取知识库回答接口
   * @param content 问题
   * @param questionId 问题id
   * @param isNotUse
   */
  function getKnowledgeMessage(content, questionId, isNotUse = false) {
    // 接口响应前加loading
    addMessageItem(false);
    setInputDisable(true);
    const messageId = generateUUID();
    // 发送消息
    let form = JSON.parse(localStorage.getItem('goclouds-chat-form'));
    let userName = (form ? form.username : '') || chatConfig.username;
    let userEmail = (form ? form.userEmail : '') || '';
    let phoneNumber = (form ? form.phoneNumber : '') || '';
    let params = {
      channelId: chatConfig.channelId,
      companyId: chatConfig.companyId,
      isCheckAI: '1',
      language: navigator.language,
      questions: content.trim(),
      chatUserName: userName,
      desAddress: userEmail,
      phoneNumber: phoneNumber,
      sessionId: sessionId || '',
      qid: questionId || '',
      chatMember: chatConfig.userMobile || '',
      memberId: chatConfig.memberId || '',
      multiRounds: true,
      useIntention: true,
      chatHistory: getHistorySession(),
    };
    // console.log('发送消息params》〉》〉', params);
    // console.log('Knowledge - Params', params);
    getKnowledgeReply(params).then((res) => {
      // console.log('Knowledge - Reply', res);
      if (res.code === 200) {
        let data = res.data;
        if (data && data.workOrderId) {
          sessionId = data.workOrderId;
          updateCacheProperty('workOrderId', data.workOrderId);
        } else {
        }
        // 类型为1表示问答库
        if (data.knowledgeTypeCode === 1 && data.answerPreviewList.length > 0) {
          // 回答内容
          // let answers = data.answerPreviewList[0].answers;
          data.answerPreviewList.forEach((item, index) => {
            // 消息内容
            let content = item.answer;
            // 消息类型
            let contentType = '';
            // 推荐消息列表
            let list = [];
            // 发送文字消息
            if (item.atype === 1) {
              contentType = 'text/plain';
              item.buttons.forEach((b) => {
                list.push({ id: b.qid, name: b.name });
              });
            }
            // 发送图片消息
            else if (item.atype === 2) {
              contentType = 'image';
              item.buttons.forEach((b) => {
                list.push({ id: b.qid, name: b.name });
              });
            }
            // 发送视频消息
            else if (item.atype === 3) {
              contentType = 'video';
              item.buttons.forEach((b) => {
                list.push({ id: b.qid, name: b.name });
              });
            }

            // 消息类型不为空，执行发送消息
            if (contentType !== '') {
              if (new Date().getTime() - reciveMessageTime.current >= messageWaitTime * 60 * 1000) {
                reciveMessageTime.current = new Date().getTime();
                addMessageItem(
                  createMessageItem({
                    dataType: messageDateType.DIVIDER,
                    content: formatTime(new Date().getTime()),
                    isNotUse: true,
                    isNotCurrentSessionData: true,
                  })
                );
              }
              const message = createMessageItem({
                messageId: messageId,
                dataType: messageDateType.MESSAGE,
                role: messageRole.KNOWLEDGE,
                displayName: chatConfig.botName,
                contentType: contentType,
                content: content,
                list: list,
                isNotUse: isNotUse,
                isShowLikeBut: !isNotUse,
                likeStatus: null,
                answerId: data.id || '',
              });
              // 发送消息
              setTimeout(function () {
                addMessageItem(message);
              }, 900 * index);
            }
          });
        }
        // 类型为2表示文档库
        else if (data.knowledgeTypeCode === 2 && data.answerPreviewList.length > 0) {
          data.answerPreviewList.forEach((item) => {
            // 消息内容
            let content = item.answer;
            // 消息类型
            let contentType = 'text/plain';
            // 消息来源列表
            let list = [];

            const message = createMessageItem({
              messageId: messageId,
              dataType: messageDateType.MESSAGE,
              role: messageRole.KNOWLEDGE,
              displayName: chatConfig.botName,
              contentType: contentType,
              content: content,
              list: list,
              isNotUse: isNotUse,
              isShowLikeBut: !isNotUse,
              likeStatus: null,
              answerId: data.id || '',
            });
            // 发送消息
            setTimeout(function () {
              addMessageItem(message);
            }, 900);
          });
        }
      } else if (res.code === 201) {
        let data = res.data;
        if (data && data.workOrderId) {
          sessionId = data.workOrderId;
          updateCacheProperty('workOrderId', data.workOrderId);
        }
        // 未获取到消息，未知回复消息。
        const message = createMessageItem({
          messageId: messageId,
          dataType: messageDateType.MESSAGE,
          role: messageRole.KNOWLEDGE,
          displayName: chatConfig.botName,
          contentType: 'text/markdown',
          content: chatConfig.chatKnowledgeUnknownReply,
          list: [],
          isNotUse: isNotUse,
          isShowLikeBut: !isNotUse,
          likeStatus: null,
        });
        if (data && data.id) {
          message.answerId = data.id || '';
        }
        // 判断是否开启转人工功能
        if (chatConfig.chatKnowledgeUnknownTransferAgent === '1' && chatConfig.menuToAgentTxt) {
          message.list = [{ id: '0', name: chatConfig.menuToAgentTxt.split(',')[0] }];
        }
        // 发送消息
        addMessageItem(message);
      } else {
        // 未获取到消息，未知回复消息。
        const message = createMessageItem({
          messageId: messageId,
          dataType: messageDateType.MESSAGE,
          role: messageRole.KNOWLEDGE,
          displayName: chatConfig.botName,
          contentType: 'text/markdown',
          content: chatConfig.chatKnowledgeUnknownReply,
          isNotUse: isNotUse,
          isShowLikeBut: !isNotUse,
          likeStatus: null,
          answerId: res.data.id || '',
        });
        // 判断是否开启转人工功能
        if (chatConfig.chatKnowledgeUnknownTransferAgent === '1') {
          message.list = [{ id: '0', name: chatConfig.menuToAgentTxt.split(',')[0] }];
        }
        // 发送消息
        addMessageItem(message);
      }
      setInputDisable(false);
    });
  }
  async function getToken() {
    await updateToken().then((res) => {
      // console.log('updateToken<<<<', res);
      if (res) {
        token = res;
      }
    });
  }
  function sortObjectKeysLexicographically(obj) {
    return Object.keys(obj)
      .sort((a, b) => a.localeCompare(b)) // 按字典顺序排序
      .reduce((acc, key) => {
        acc[key] = obj[key];
        return acc;
      }, {});
  }

  /**
   * 获取知识库回答接口-流式响应
   * @param content 问题
   * @param questionId 问题id
   */
  async function getKnowledgeMessageStream(content, questionId, faqId, noLoad = false) {
    // console.log('getKnowledgeMessageStream<<<<', content);
    // console.log('getKnowledgeMessageStream<<<<', questionId);
    // await getToken();
    // 接口响应前加loading
    // console.log('noLoad', noLoad);
    setInStream(true);
    if (!noLoad) {
      addMessageItem(false);
    }
    setInputDisable(true);
    const messageId = generateUUID();
    let form = JSON.parse(localStorage.getItem('goclouds-chat-form'));
    let userName = (form ? form.username : '') || chatConfig.username;
    let userEmail = (form ? form.userEmail : '') || '';
    let phoneNumber = (form ? form.phoneNumber : '') || '';
    // updateCacheProperty('imChatSessionId', e.data.sessionId);//更新sessionId和workOrderId
    let params = {
      prompt: content.trim(),
      company_id: chatConfig.companyId,
      knowledge_id: chatConfig.documentKnowledgeBaseId,
      // knowledge_id: '1887826385784901634',
      // knowledge_id: '1901492128411619329',
      use_faq: true,
      faq_id: faqId,
      multi_rounds: chatConfig.docBotFlag === '1' ? true : false,
      use_stream: true,
      use_qa: chatConfig.docBotFlag === '1' ? true : false,
      use_intention: true,
      use_genai: chatConfig.docBotFlag === '1' ? true : false,
      chat_history: getHistorySession(),
      extent_attr: [],
      mood_board_flag: 0,
      refuse_answer: chatConfig.chatKnowledgeUnknownReply,
    };
    if (chatConfig.faqUseDeviceLanguage) {
      params.language_code = navigator.language;
    }
    // console.log('发送消息params》〉》〉', params);
    // console.log('Knowledge - Stream - Params', params);
    // return;
    let finalAnswer = {};
    let token = JSON.parse(localStorage.getItem('connectNowToken'));
    let isFaq = false;
    // await checkWorkTime();
    try {
      fetchEventSource(getKnowledgeReplyStreamPython(), {
        method: 'POST',
        headers: {
          Authorization: token,
        },
        body: JSON.stringify(params),
        cache: 'no-store', // 防止缓存
        async onopen(response) {
          // console.log('SSE 连接', response);
          if (response.ok) {
            console.log('SSE 连接成功');
            addMessageItem(true);
          } else {
            // console.log('SSE 连接成功', response);
            if (response.status == 401) {
              token = await getToken();
              // addMessageItem(true);
              setTimeout(() => {
                getKnowledgeMessageStream(content, questionId, faqId, true);
              }, 0);
            } else {
              console.log('SSE连接失败', response);
              addMessageItem(true);
            }
          }
        },
        async onmessage(event) {
          // console.log('Knowledge - Stream - Event', JSON.parse(event.data));
          const data = JSON.parse(event.data);
          if (data !== '' && data !== 'data:') {
            if (data.statusCode === 400) {
              const message = createMessageItem({
                messageId: messageId,
                dataType: messageDateType.MESSAGE,
                role: messageRole.KNOWLEDGE,
                displayName: chatConfig.botName,
                contentType: 'text/markdown',
                content: chatConfig.chatKnowledgeUnknownReply,
                list: [],
                isNotUse: false,
                isShowLikeBut: false,
                likeStatus: null,
              });
              addMessageItem(message);
            } else {
              // 判断finish不为true是进入显示, 为true时表示回答结束保存workOrderId
              if (!data.finish) {
                let answer = data.answer;
                let faq = data.faq;
                isFaq = faq;
                // 如果是faq
                if (faq) {
                  let item = data;
                  // 消息内容
                  let content = answer;
                  // 消息类型
                  let contentType = '';
                  // 推荐消息列表
                  let list = [];
                  // 发送文字消息
                  if (item.atype === 1) {
                    contentType = 'text/plain';
                    item.buttons.forEach((b) => {
                      list.push({ id: b.qid, name: b.name });
                    });
                  }
                  // 发送图片消息
                  else if (item.atype === 2) {
                    contentType = 'image';
                    item.buttons.forEach((b) => {
                      list.push({ id: b.qid, name: b.name });
                    });
                  }
                  // 发送视频消息
                  else if (item.atype === 3) {
                    contentType = 'video';
                    item.buttons.forEach((b) => {
                      list.push({ id: b.qid, name: b.name });
                    });
                  }

                  // 消息类型不为空，执行发送消息
                  if (contentType !== '') {
                    const message = createMessageItem({
                      messageId: messageId,
                      dataType: messageDateType.MESSAGE,
                      role: messageRole.KNOWLEDGE,
                      displayName: chatConfig.botName,
                      contentType: contentType,
                      content: content,
                      list: list,
                      isNotUse: false,
                      isShowLikeBut: true,
                      likeStatus: null,
                    });
                    addMessageItem(message);
                  }
                } else {
                  // 不是faq不用判断内容类型
                  const newMessage = createMessageItem({
                    dataType: messageDateType.MESSAGE,
                    role: messageRole.KNOWLEDGE,
                    displayName: chatConfig.botName,
                    contentType: 'text/markdown',
                    content: answer,
                    list: [],
                    messageId: messageId,
                    time: getCurrentDateTime(),
                    chatUserName: customerName,
                    chatEmail: formData['chat_email'],
                    chatPhoneNumber: formData['chat_phone_number'],
                    isNotUse: false,
                    isShowLikeBut: true,
                    likeStatus: null,
                    answerId: messageId || '',
                  });
                  setMessageList((prevList) => {
                    // 检查messageId是否已存在于messageList中
                    const existingMessageIndex = prevList.findIndex(
                      (message) => message.messageId === newMessage.messageId
                    );
                    if (existingMessageIndex !== -1) {
                      // 如果已存在，则在原content字段中追加新的content
                      const updatedList = [...prevList];
                      updatedList[existingMessageIndex] = {
                        ...updatedList[existingMessageIndex],
                        content: updatedList[existingMessageIndex].content + newMessage.content,
                      };
                      console.log(
                        `[setMessageList] Line 1370: Setting messageList to:`,
                        JSON.stringify(updatedList, null, 2)
                      );
                      messageListRef.current = updatedList;
                      return updatedList;
                    } else {
                      // 如果不存在，则新增一项message元素
                      const newList = [...prevList, newMessage];
                      console.log(
                        `[setMessageList] Line 1370: Setting messageList to:`,
                        JSON.stringify(newList, null, 2)
                      );
                      messageListRef.current = newList;
                      return newList;
                    }
                  });
                }
              } else {
                console.log('data', data);
                sendDelayMessage(1);
                finalAnswer = data;
                finalAnswer.agentTime = new Date().getTime();
                // if (!sessionId) {
                let params = {
                  channelTypeId: device === 'mobile' ? '9' : '8',
                  channelId: chatConfig.channelId,
                  companyId: chatConfig.companyId,
                  isCheckAI: '1',
                  language: navigator.language,
                  questions: content.trim(),
                  chatUserName: userName,
                  desAddress: chatConfig.fingerprintId,
                  phoneNumber: phoneNumber,
                  sessionId: sessionId || '',
                  qid: questionId || '',
                  chatMember: chatConfig.userMobile || '',
                  memberId: chatConfig.memberId || '',
                  multiRounds: true,
                  useIntention: true,
                  chatHistory: JSON.stringify(getHistorySession()),
                  faqId: faqId || '',
                  ticketAttr: JSON.stringify(chatConfig.ticketAttr),
                  streamData: JSON.stringify(finalAnswer),
                  userTime: userTime,
                  chatName: chatConfig.botName,
                };
                params = sortObjectKeysLexicographically(params);
                let ts = new Date().getTime();
                let sign =
                  'client_id=' +
                  process.env.CLIENT_ID +
                  '&ts=' +
                  ts +
                  '&body=' +
                  JSON.stringify(params) +
                  '&client_secret=' +
                  process.env.SECURITY_KEY;
                let header = {
                  ts: ts,
                  sign: CryptoJS.MD5(sign.toLocaleLowerCase()).toString(CryptoJS.enc.Hex),
                };
                //创建新的工单
                await createOrder(params, header).then((res) => {
                  if (res?.code == 200 && res?.data != null) {
                    let data = JSON.parse(res?.data);
                    if (!sessionId) {
                      sessionId = data?.workOrderId;
                      updateCacheProperty('workOrderId', data?.workOrderId);
                      updateCacheProperty('imChatSessionId', data?.sessionId); //更新sessionId和workOrderId
                    }
                  }
                });
                // }
                // 设置消息体中的答案id，用于点赞点踩
                let answerId = data.id || '';
                setMessageList((prevList) => {
                  const updatedList = prevList.map((m) =>
                    m.messageId === messageId ? { ...m, answerId: answerId } : m
                  );
                  console.log(
                    `[setMessageList] Line 1452: Setting messageList to:`,
                    JSON.stringify(updatedList, null, 2)
                  );
                  messageListRef.current = updatedList;
                  return updatedList;
                });
              }
            }
          }
        },
        async onerror(err) {
          // console.error('SSE 连接错误:', err);
          addMessageItem(true);
          setInputDisable(false);
          setInStream(false);
          throw err;
        },
        async onclose(event) {
          // console.log('SSE 连接关闭sessionId', sessionId);
          // console.log('SSE resp', event);
          // let historyArr = getHistorySession();
          // console.log('histroyArr', historyArr);
          // 在关闭连接时候判断，如果sessionId不存在，则创建一个工单
          setInputDisable(false);
          setInStream(false);
        },
      });
    } catch (error) {
      setInStream(false);
      console.error('Error sending SSE POST request:', error);
    }
  }

  /**
   * 发送知识库消息
   * @param message 消息
   * @param knowledge 是否调用知识库接口回复
   */
  function sendKnowledgeMessage(message, knowledge = true) {
    // console.log('sendKnowledgeMessage>>>', message);
    // console.log('sendKnowledgeMessage>>>', knowledge);
    addMessageItem(message);
    if (knowledge) {
      // getKnowledgeMessage(message.content);
      getKnowledgeMessageStream(message.content, message.qid || '', message.faqId);
    }
  }

  // ============================================================================== CONNECT人工

  /**
   * 加载Connect渠道
   */
  async function loadConnectChannel() {
    setChannel(channelState.IM_CHAT);
    loadIMChatChannel();
    return;
    try {
      setAgentDisabled(false); // 转人工置为不可用

      let chatDetails = null;

      // 判断缓存中是否存在进行中的聊天
      if (isChatting || !isDisconnect) {
        const result = findMessageDataItem(chatConfig.channelId, messageIdRef.current);
        console.log('1234567>>result.list', result.list);
        if (result) {
          setMessageList(result.list);
          messageListRef.current = result.list;
          if (result.connectChatSession) {
            chatDetails = result.connectChatSession;
          }
        }
      }

      // 如果令牌token为空，重新获取
      if (chatDetails === null) {
        // 接口响应前加loading
        addMessageItem(false);
        // 请求connect获取连接信息
        let connectResult = await requestConnect(initiateChatRequest);
        // connect ParticipantToken令牌
        chatDetails = connectResult.data.startChatResult;
      }

      // 创建CONNECT连接
      chatSession = await connect.ChatSession.create({
        chatDetails: chatDetails,
        type: 'CUSTOMER',
        options: { region: initiateChatRequest.region },
      });

      // 对chatSession对象添加消息监听事件
      addEventListeners();

      // 建立连接，此步骤控制是否与connect建立连接
      chatSession.connect().then(
        (res) => {
          setChannel(channelState.CONNECT);
          // 连接成功
          // 缓存IM连接上服务后返回的数据
          updateCacheProperty('connectChatSession', chatDetails);
          // 更新'inProgress'缓存值中channel值
          cacheInProgress('channel', channelState.CONNECT);
        },
        (error) => {
          setAgentDisabled(true); // 转人工置为可用
        }
      );
    } catch (e) {
      console.log('连接Connect Exception', e);
      setAgentDisabled(true); // 转人工置为可用
      setLoading(false);
      setError('很抱歉，请检查配置或联系管理员');
    }
  }

  /**
   * 添加Connect事件
   */
  function addEventListeners() {
    // 添加chat断开事件的监听
    chatSession.onEnded(handleConnectEnded);
    // 添加消息事件的监听
    chatSession.onMessage(handleConnectIncomingData);
    // 添加chat已读未读事件
    chatSession.onReadReceipt(handledConnectReadReceipt);
    chatSession.onDeliveredReceipt(handledConnectDeliveredReceipt);
  }

  /**
   * Connect消息事件
   * @param item
   * @returns {Promise<void>}
   */
  async function handleConnectIncomingData(item) {
    console.log('CONNECT Listeners Data', item);

    // 定义消息体内容
    let message = {
      // 消息类型
      dataType: item.data.Type,
      // 消息角色
      role: item.data.ParticipantRole,
      // 名称
      displayName: item.data.DisplayName,
      // 内容类型
      contentType: item.data.ContentType,
      // 消息内容
      content: '',
      // 推荐消息列表
      list: [],
      // 消息id
      messageId: '',
      messageStatus: chatConfig.messageSending,
      uploadProgress: 100,
      uploadStatus: 'none',
    };
    // 判断消息类型，EVENT/ATTACHMENT/MESSAGE
    if (item.data.Type === 'EVENT') {
      // 加入事件
      if (item.data.ContentType === 'application/vnd.amazonaws.connect.event.participant.joined') {
        let suffix = chatConfig.joinChatMessage;
        message.content = item.data.DisplayName + ' ' + suffix;
        // 如果坐席加入回话
        if (message.role === messageRole.AGENT) {
          setEvaluationState(true);
          setContactId(chatSession.controller.contactId);
        }
      } else if (item.data.ContentType === 'application/vnd.amazonaws.connect.event.chat.ended') {
        // 聊天结束事件
        message.content = chatConfig.endChatMessage;
      } else {
        return;
      }
    } else if (item.data.Type === 'ATTACHMENT') {
      message.dataType = 'MESSAGE';

      // 附件数据
      let attachment = {
        // 附件id，用于获取附件在S3中的信息
        attachmentId: item.data.Attachments[0].AttachmentId,
        // 附件原名称
        attachmentName: item.data.Attachments[0].AttachmentName,
        // 附件类型
        attachmentContentType: item.data.Attachments[0].ContentType,
        // 附件S3地址
        attachmentUrl: '',
        ticketAttr: chatConfig.ticketAttr,
      };

      // 获取附件的S3信息
      const awsSdkResponse = await chatSession.downloadAttachment({
        attachmentId: attachment.attachmentId,
      });

      attachment.attachmentUrl = URL.createObjectURL(awsSdkResponse);

      // 判断附件的类型 video/image/其他link
      // 如果文件类型是图片
      if (isImage(attachment.attachmentName)) {
        message.contentType = 'image';
      }
      // 如果文件类型是视频
      else if (isVideo(attachment.attachmentName)) {
        message.contentType = 'video';
      } else {
        message.contentType = 'link';
      }
      message.content = attachment.attachmentUrl;
      message.contentFileObject = awsSdkResponse;
      message.fileName = attachment.attachmentName;
    } else {
      // 如果名称是SYSTEM_MESSAGE，则替换为配置项中的名称
      if (message.displayName === 'SYSTEM_MESSAGE') {
        message.displayName = chatConfig.botName;
      }

      // 如果不是客户角色，则把角色类型替换为坐席
      if (item.data.ParticipantRole !== messageRole.CUSTOMER) {
        message.role = messageRole.AGENT;
      }

      // connect回传过来的消息内容
      let content = item.data.Content;
      // 判断消息内容是否附件。
      const regex = /^\[(.*?)\]\((.*?)\)$/;
      const isMatch = regex.test(content);
      // 如果是附件
      if (isMatch) {
        // 获取文件名称和链接。
        const result = regex.exec(content);
        const fileName = result[1];
        const fileLink = result[2];
        // 如果文件类型是图片
        if (isImage(fileName)) {
          message.contentType = 'image';
        }
        // 如果文件类型是视频
        else if (isVideo(fileName)) {
          message.contentType = 'video';
        } else {
          message.contentType = 'link';
        }
        message.content = fileLink;
        message.fileName = fileName;
      }
      // 如果是文本
      else {
        // 如果不是客户的消息
        if (item.data.ParticipantRole !== messageRole.CUSTOMER) {
          // 图片链接正则
          const imgRegex = /^https?:\/\/.*\.(?:jpe?g|png|jpeg|gif)$/i;
          // 视频链接正则
          const videoRegex = /^https?:\/\/.*\.mp4$/i;
          // 消息内容首尾去空格
          let contentTemp = content.trim();
          // 如果内容是图片链接。
          if (imgRegex.test(contentTemp)) {
            message.contentType = 'image';
            content = contentTemp;
          }
          // 如果内容是视频链接。
          else if (videoRegex.test(contentTemp)) {
            message.contentType = 'video';
            content = contentTemp;
          }
        } else if (item.data.ParticipantRole === messageRole.CUSTOMER) {
          // 如果是客户，记录messageId
          message.messageId = item.data.Id;
        }
        message.content = content;
      }
    }
    // 执行渲染发送消息
    addMessageItem(message);
  }

  /**
   * Connect结束事件
   */
  function handleConnectEnded() {
    console.log('CONNECT Listeners Ended');
    // 处理连接关闭逻辑
    setAgentDisabled(true); // 转人工可用
    setChannel(channelState.KNOWLEDGE); // 连接断开将渠道改为知识库
    cacheHistorySession('isDisconnect', true); // 更新缓存中的聊天断开状态
    setOperationState(true); // 开启关闭窗口模块
    // 判断是否连接上人工
    if (getEvaluationState()) {
      addEvaluationItem();
    }
  }

  /**
   * Connect发送消息
   * @param content 消息内容
   * @param contentType 内容类型
   * @param fileName 文件名称，用于链接
   */
  async function sendConnectMessage(content, contentType, fileName) {
    try {
      if (!chatSession) return;
      // 如果contentType不为空表示时附件消息，此时转换content内容格式。
      if (contentType) {
        content = '[' + fileName + ']' + '(' + content + ')';
      }
      chatSession.sendMessage({ message: content, contentType: 'text/markdown' });
    } catch (e) {
      addEventItem('发送消息失败，请稍后再试或联系管理员');
    }
  }

  /**
   * Connect消息已读事件
   * @param item
   * @returns {Promise<void>}
   */
  async function handledConnectReadReceipt(item) {
    setMessageList((prevList) => {
      let arr = prevList.map((message) =>
        message.messageId === item.data.MessageMetadata.MessageId
          ? { ...message, messageStatus: chatConfig.messageRead }
          : message
      );
      messageListRef.current = [...arr];
      return arr;
    });
  }

  /**
   * Connect发送消息成功事件
   * @param item
   * @returns {Promise<void>}
   */
  async function handledConnectDeliveredReceipt(item) {
    setMessageList((prevList) => {
      let arr = prevList.map((message) =>
        message.messageId === item.data.MessageMetadata.MessageId
          ? { ...message, messageStatus: chatConfig.messageDelivered }
          : message
      );
      messageListRef.current = [...arr];
      return arr;
    });
  }

  // ============================================================================== IM_CHAT人工

  /**
   * 加载IM-CHAT渠道
   */
  async function loadIMChatChannel() {
    console.log('调用了loadIMChatChannel');
    console.log(chatConfig.chatOpenChannelType);
    //如果仅人工的情况进入查询坐席工作时间
    if (chatConfig.chatOpenChannelType === '3') {
      cacheInProgress('channel', channelState.IM_CHAT);
      const result = await findMessageDataItem(chatConfig.channelId, messageIdRef.current);
      if (result) {
        updateCacheProperty('workOrderId', result.workOrderId);
        setMessageList(result.list);
        messageListRef.current = result.list;
        // sessionId = result.workOrderId;
        // updateCacheProperty('workOrderId', result.workOrderId);
      }
      let form = JSON.parse(localStorage.getItem('goclouds-chat-form'));
      let userName = (form ? form.username : '') || chatConfig.username;
      let phoneNumber = (form ? form.phoneNumber : '') || '';
      let params = {
        channelId: chatConfig.channelId,
        chatUserName: userName,
        ticketId: sessionId,
        customerContactInfo: phoneNumber,
      };
      params = sortObjectKeysLexicographically(params);
      let ts = new Date().getTime();
      let sign =
        'client_id=' +
        process.env.CLIENT_ID +
        '&ts=' +
        ts +
        '&body=' +
        JSON.stringify(params) +
        '&client_secret=' +
        process.env.SECURITY_KEY;
      let header = {
        ts: ts,
        sign: CryptoJS.MD5(sign.toLocaleLowerCase()).toString(CryptoJS.enc.Hex),
      };
      await checkWorkTime(params, header).then((res) => {
        addMessageItem(true);
        if (res?.code == 200 && chatConfig.openSelfChat === '1' && res?.data == 1) {
          console.log('在工作时间开始转人工');
          if (!getInputDisable()) {
            addMessageItem(false);
          }
          // 转人工置灰
          setInputDisable(true);
          setAgentDisabled(false);
          // 重置IMWebClient对象
          IMWebClient.reset();
          // 设置事件回调函数
          IMWebClient.on('open', handleIMChatConnectFinished);
          IMWebClient.on('message', handleIMChatIncomingMessage);
          IMWebClient.on('close', handleIMChatConnectClosed);
          // 开启连接
          IMWebClient.connect();
        } else if (res?.code == 200 && res?.data == 0) {
          console.log('不在工作时间，不转人工');
          addEventItem(chatConfig.notWorkTime, 'noAgent');
        } else {
          console.log('没有人工渠道');
        }
      });
    } else {
      if (!getInputDisable()) {
        addMessageItem(false);
      }
      // 转人工置灰
      setInputDisable(true);
      setAgentDisabled(false);
      // 重置IMWebClient对象
      IMWebClient.reset();
      // 设置事件回调函数
      IMWebClient.on('open', handleIMChatConnectFinished);
      IMWebClient.on('message', handleIMChatIncomingMessage);
      IMWebClient.on('close', handleIMChatConnectClosed);
      // 开启连接
      IMWebClient.connect();
    }
  }

  /**
   * 处理IM开启连接后
   */
  async function handleIMChatConnectFinished() {
    console.log('handleIMChatConnectFinished type>>>', reconnectType.current);
    // 更新渠道为IM人工
    setChannel(channelState.IM_CHAT);
    let imChatSessionId = '';
    let imChatUid = '';
    // 获取历史会话信息

    const result = await findMessageDataItem(chatConfig.channelId, messageIdRef.current);
    // 优先从缓存中获取会话信息
    let inProgress = null;
    try {
      inProgress = JSON.parse(localStorage.getItem('inProgress'));
    } catch (error) {
      console.error('Failed to parse inProgress:', error);
    }

    if (result && result.list && result.list.length > 0) {
      if (result.messageDataId === messageDataId) {
        setMessageList(result.list);
        messageListRef.current = result.list;
      }
      if (result.imChatSessionId) {
        imChatSessionId = result.imChatSessionId;
        console.log('从历史记录获取 imChatSessionId:', imChatSessionId);
      }
      if (result.imChatUid) {
        imChatUid = result.imChatUid;
        console.log('从历史记录获取 imChatUid:', imChatUid);
      }
    }
    // 如果历史记录中没有，尝试从inProgress中获取
    if (!imChatSessionId && inProgress && inProgress.imChatSessionId) {
      imChatSessionId = inProgress.imChatSessionId;
      console.log('从inProgress获取 imChatSessionId:', imChatSessionId);
    }
    if (!imChatUid && inProgress && inProgress.imChatUid) {
      imChatUid = inProgress.imChatUid;
      console.log('从inProgress获取 imChatUid:', imChatUid);
    }
    if (imChatUid === '') {
      imChatUid = generateUUID();
      console.log('生成新的 imChatUid:', imChatUid);
    }
    if (reconnectType.current) {
      imChatSessionId = '';
      imChatUid = generateUUID();
      updateCacheProperty('imChatUid', imChatUid);
      updateCacheProperty('imChatSessionId', imChatSessionId);
      localStorage.setItem('imChatUid', imChatUid);
      localStorage.setItem('imChatSessionId', imChatSessionId);
    }
    let attributes = {
      workOrderId: sessionId || '',
      channelId: chatConfig.channelId,
      // 缓存中的用户信息。
      chat_user_name: formData.chat_user_name || chatConfig.username,
      chat_phone_number: formData.chat_phone_number || '',
      customerPhone: formData.chat_phone_number || '',
      fingerprintId: chatConfig.fingerprintId,
      chat_email: formData.chat_email || chatConfig.userEmail,
      // 外部传入的用户信息
      chat_mobile: chatConfig.userMobile,
      chat_member_id: chatConfig.memberId,
    };
    // 执行连接SOCKET
    IMWebClient.bindAccount({
      uid: imChatUid,
      username: customerName,
      tenantId: chatConfig.companyId,
      sessionId: imChatSessionId,
      channelType: device === 'mobile' ? '9' : '8',
      contactAttributes: JSON.stringify(attributes),
      ticketAttr: JSON.stringify(chatConfig.ticketAttr),
    });
    // 设置当前会话断开状态为false，用于im重连使用，（重要勿动）
    reconnectType.current = false;
    setDisconnect(false);
  }

  /**
   * 处理IM断开连接后
   */

  async function handleIMChatConnectClosed(code) {
    await findMessageDataItem(chatConfig.channelId, messageDataId).then((res) => {
      if (res) {
        if (res.list?.length > 0) {
          console.log('handleIMChatConnectClosed存在未接收的消息messageList>>>', res.list);
          setMessageList(res.list);
          messageListRef.current = res.list;
        }
        // messageListRef.current = res.list;
      }
    });

    // debugger;
    console.log('handleIMChatConnectClosed code>>>', code, 'reconnectCount:', imReconnectCount);
    // 重连逻辑的代码：1006（网络异常）、1000（连接失败）
    if (code === 1006) {
      if (imReconnectCount < maxReconnectAttempts) {
        setInputDisable(true);
        setImReconnectCount((prev) => prev + 1);
        console.log(`尝试重连 IM (${imReconnectCount + 1}/${maxReconnectAttempts})`);
        // 指数退避重连延迟
        const delay = Math.min(1000 * Math.pow(2, imReconnectCount), 10000);
        setTimeout(() => {
          loadIMChatChannel(true);
        }, delay);
      } else {
        console.error('IM重连次数已达上限，停止重连');
        // addEventItem('连接失败，请稍后再试或刷新页面');
        // setInputDisable(false);
      }
    } else if (code === 1005 || code === 1000) {
      // debugger;
      console.log('ws断开了，code1005', code);
      let inProgress = JSON.parse(localStorage.getItem('inProgress')) || {};
      console.log('inProgress>>>1005', inProgress);
      if (!chatConfig.singleChat) {
        cacheHistorySession('isDisconnect', true); // 更新缓存中的聊天断开状态
        localStorage.removeItem('inProgress');
        setOperationState(true); // 开启关闭窗口模块
        setIsEndChat(true);
        setInputDisable(true);
        // 判断是否发送评分消息
        if (getEvaluationState()) {
          // 是否存在评分数据。
          let isExist = null;
          setMessageList((pre) => {
            isExist = pre.find((item) => item.dataType === messageDateType.EVALUATION);
            return pre;
          });
          if (isExist) {
            setEvaluationState(false); // 底部不显示笑脸和邀请评分文案
          } else {
            addEvaluationItem(messageIdRef.current, sessionId, IMWebClient.session.uid);
          }
        }
      } else {
        if (getEvaluationState()) {
          // 是否存在评分数据。
          let isExist = null;
          setMessageList((pre) => {
            isExist = pre.find(
              (item) => item.dataType === messageDateType.EVALUATION && item.isNotCurrentSessionData !== true
            );
            return pre;
          });
          if (isExist) {
            // setEvaluationState(false); // 底部不显示笑脸和邀请评分文案
          } else {
            addEvaluationItem(messageIdRef.current, sessionId, IMWebClient.session.uid);
          }
        }
        console.log('回归到原本设置的channel>>>', channel);
        setIsEndChat(true);
        setMessageDataId('');
        messageIdRef.current = '';
        setAgentDisabled(true);
        reconnectType.current = true;
        localStorage.removeItem('inProgress');
        sessionId = '';
        let msgId = generateTimestampString();
        setMessageDataId(msgId);
        messageIdRef.current = msgId;
        cacheHistorySession('isDisconnect', true); // 更新缓存中的聊天断开状态
        // debugger;
        if (chatConfig.chatOpenChannelType == 1) {
          console.log('收到1005、1000回到智能客服');
          messageListRef.current = [];
          setMessageList([]);
          setChannel(channelState.KNOWLEDGE);
          channelRef.current = channelState.KNOWLEDGE;
          setTimeout(() => {
            loadChatChannel(null, channelState.KNOWLEDGE);
          }, 500);
        } else {
          console.log('收到1005、1000回到IM');
          isReconnectRef.current = true;
          IMWebClient.reset();
          IMWebClient.stop();
          setChannel(channelState.IM_CHAT);
          channelRef.current = channelState.IM_CHAT;
        }
      }
    }

    /*// 服务不可用
    if (code === 1006) {
      /!*addMessageItem(
        createMessageItem({
          dataType: messageDateType.EVENT,
          content: 'Service Unavailable',
        })
      );*!/
      // console.log('IMChat Service Unavailable');
      let message = createMessageItem({
        dataType: messageDateType.EVENT,
        content: chatConfig.endChatMessage,
      });
      addMessageItem(message);
    }
    // 连接失败
    if (code === 1000) {
      /!*addMessageItem(
        createMessageItem({
          dataType: messageDateType.EVENT,
          content: 'Connect Fail',
        })
      );*!/
      // console.log('IMChat Connect Fail Session Exception');
      let message = createMessageItem({
        dataType: messageDateType.EVENT,
        content: chatConfig.endChatMessage,
      });
      addMessageItem(message);
    }
    /!* // 处理连接关闭逻辑
     setAgentDisabled(true); // 转人工可用
     setChannel(channelState.KNOWLEDGE); // 连接断开将渠道改为知识库
     cacheHistorySession('isDisconnect', true); // 更新缓存中的聊天断开状态
     setOperationState(true); // 开启关闭窗口模块
     // 判断是否连接上人工
     if (getEvaluationState()) {
       addEvaluationItem();
     }*!/

    cacheHistorySession('isDisconnect', true); // 更新缓存中的聊天断开状态
    setOperationState(true); // 开启关闭窗口模块
    // 判断是否发送评分消息
    if (getEvaluationState()) {
      // 是否存在评分数据。
      let isExist = null;
      await setMessageList((pre) => {
        isExist = pre.find((item) => item.dataType === messageDateType.EVALUATION);
        console.log(`[setMessageList] Line 2072: Setting messageList to:`, JSON.stringify(pre, null, 2));
        return pre;
      });
      if (isExist) {
        setEvaluationState(false); // 底部不显示笑脸和邀请评分文案
        return;
      }
      addEvaluationItem();
    }*/
  }
  /**
   * 格式化时间戳，今天的时间显示HH:MM，其他日期显示YYYY-MM-DD HH:MM
   * @param {number | string} timestamp - 毫秒级时间戳（数字或字符串形式）
   * @returns {string} 格式化后的时间字符串
   */
  function formatTime(timestamp) {
    // 处理时间戳输入，支持数字和字符串类型
    let numericTimestamp;
    if (typeof timestamp === 'string') {
      numericTimestamp = parseFloat(timestamp);
      if (isNaN(numericTimestamp)) {
        console.error('无效的时间戳字符串');
        return '';
      }
    } else if (typeof timestamp === 'number') {
      numericTimestamp = timestamp;
    } else {
      console.error('时间戳必须是数字或数字字符串');
      return '';
    }

    // 创建日期对象
    const date = new Date(numericTimestamp);
    if (date.toString() === 'Invalid Date') {
      console.error('无法解析为有效的日期');
      return '';
    }

    // 获取当前日期（今天）
    const today = new Date();

    // 检查是否为今天（比较年、月、日）
    const isToday =
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate();

    // 格式化小时和分钟（确保两位数）
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    // 如果是今天，只返回时分
    if (isToday) {
      return `${hours}:${minutes}`;
    }

    // 不是今天则返回完整日期时间
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }

  /**
   * 处理IM事件消息监听
   * @param e 接收到的消息内容
   */
  async function handleIMChatIncomingMessage(e) {
    // console.log('handleIMChatIncomingMessage', e);
    let type = e.type;
    // 系统消息

    if (type === 'event') {
      if (
        e.code == IMWebClient.config.CODE_ERROR &&
        e.key == IMWebClient.config.KEY_CLIENT_BIND &&
        chatConfig.singleChat
      ) {
        console.log('收到服务器500消息', successChatCountRef);
        await findMessageDataItem(chatConfig.channelId, messageIdRef.current).then((res) => {
          if (res) {
            let messageList = res.list;
            if (messageList?.length > 0) {
              console.log('500存在未接收的消息messageList>>>', messageList);
              setMessageList(messageList);
              messageListRef.current = messageList;
            }
          }
        });
        // if (messageListRef.current[messageListRef.current.length - 1].contentType != 'endChat') {
        //   let message = createMessageItem({
        //     dataType: messageDateType.EVENT,
        //     content: chatConfig.endChatMessage,
        //     contentType: 'endChat',
        //   });
        //   addMessageItem(message);
        // }
        setImReconnectCount(999);
        // 在这里关闭所有ws连接，防止用户手动关闭页面后，ws连接还在后台运行
        IMWebClient.reset();
        IMWebClient.stop();
        // 断开所有连接
        IMWebClient.disconnect({ tenantId: chatConfig.companyId });
        setIsEndChat(true);
        setInputDisable(false);
        cacheHistorySession('isDisconnect', true); // 更新缓存中的聊天断开状态
        localStorage.removeItem('inProgress');
        setAgentDisabled(true);
        reconnectType.current = true;
        sessionId = '';
        let msgId = generateTimestampString();
        setMessageDataId(msgId);
        messageIdRef.current = msgId;
        if (chatConfig.chatOpenChannelType == 1) {
          messageListRef.current = [];
          setMessageList([]);
          setChannel(channelState.KNOWLEDGE);
          loadChatChannel(null, channelState.KNOWLEDGE);
        } else {
          setChannel(channelState.IM_CHAT);
        }
        return;

        // else {
        // return
        // setIsEndChat(true);
        // reconnectType.current = true;
        // setInputDisable(false);
        // // 在重置messageIdRef之前，先保存当前的消息历史
        // console.log('准备重置连接，先保存当前消息历史');
        // messageListRef.current = [];
        // setMessageList([]);
        // messageIdRef.current = '';
        // setIsEndChat(true);
        // setMessageDataId('');
        // messageIdRef.current = '';
        // setAgentDisabled(true);
        // reconnectType.current = true;
        // localStorage.removeItem('inProgress');
        // sessionId = '';
        // let msgId = generateTimestampString();
        // setMessageDataId(msgId);
        // messageIdRef.current = msgId;
        // isReconnectRef.current = true;
        // IMWebClient.reset();
        // IMWebClient.stop();
        // loadChatChannel();
        // return;
        // }
      } else if (e.code == IMWebClient.config.CODE_ERROR && e.key == IMWebClient.config.KEY_CLIENT_BIND) {
        await findMessageDataItem(chatConfig.channelId, messageIdRef.current).then((res) => {
          if (res) {
            let messageList = res.list;
            if (messageList?.length > 0) {
              console.log('500存在未接收的消息messageList>>>', messageList);
              setMessageList(messageList);
              messageListRef.current = messageList;
            }
          }
          cacheHistorySession('isDisconnect', true); // 更新缓存中的聊天断开状态
          localStorage.removeItem('inProgress');
          setOperationState(true); // 开启关闭窗口模块
          setEvaluationState(true);
          setAgentDisabled(true);
          setIsEndChat(true);
          setInputDisable(true);
          // 是否存在评分数据。
          let isExist = null;
          setMessageList((pre) => {
            isExist = pre.find((item) => item.dataType === messageDateType.EVALUATION);
            return pre;
          });
          if (isExist) {
            setEvaluationState(false); // 底部不显示笑脸和邀请评分文案
          } else {
            addEvaluationItem(messageIdRef.current, sessionId, IMWebClient.session.uid);
          }
        });
        // let message = createMessageItem({
        //   dataType: messageDateType.EVENT,
        //   content: chatConfig.endChatMessage,
        //   contentType: 'endChat',
        // });
        // addMessageItem(message);
        return;
      }
      // 绑定成功回调
      if (e.key === IMWebClient.config.KEY_CLIENT_BIND && e.code === IMWebClient.config.CODE_OK) {
        successChatCountRef.current = successChatCountRef.current * 1 + 1;
        // console.log('setSuccessChatCount>>>', successChatCountRef);
        console.log('************* 连接成功 *************');
        // console.log('e.data>>>', e.data);
        IMWebClient.session = e.data;
        sessionId = e.data.sessionId; // 记录当前工单会话ID，发送满意度评分时使用
        // messageIdRef.current = e.data.sessionId;
        // setMessageDataId(e.data.sessionId);
        setEvaluationState(true);
        // 重连成功，重置计数器
        setImReconnectCount(0);

        // 缓存用户id
        updateCacheProperty('imChatUid', e.data.uid);
        localStorage.setItem('imChatUid', e.data.uid);
        // 缓存IM连接上服务后返回的数据
        updateCacheProperty('imChatSessionId', e.data.sessionId);
        localStorage.setItem('imChatSessionId', e.data.sessionId);
        // 更新'inProgress'缓存值中channel值
        cacheInProgress('channel', channelState.IM_CHAT);
        // 存放未收到的消息列表
        let messageList = [];
        // 如果socket返回的状态是action_1000（已创建会话）
        if (e.message === IMWebClient.config.sessionAction.action_1000) {
          /*let message = createMessageItem({
            dataType: messageDateType.EVENT,
            content: e.data.username + ' ' + chatConfig.joinChatMessage,
          });
          addMessageItem(message);*/
          // 获取排队人数并发送排队数消息
          let sessionId = IMWebClient.session.sessionId || localStorage.getItem('imChatSessionId');
          await IMWebClient.waitCustomerCount(chatConfig.companyId, sessionId).then((res) => {
            if (res.code === 200) {
              // console.log('排队人数》〉》〉》〉》', res.data);
              // let waitCount = res.data && res.data > 0 ? res.data - 1 : 0;
              let waitCount = res.data || 0;
              let content = chatConfig.waitInLineBefore + ' ' + waitCount + ' ' + chatConfig.waitInLineLater;
              let message = createMessageItem({
                dataType: messageDateType.EVENT,
                content: content,
                sessionId: sessionId,
                contentType: 'queueCount',
                msgId: e.id,
              });
              if (waitCount > 0) {
                addMessageItem(message);
              }
            }
          });
          setTimeout(() => {
            if (imChatLaterMessageRef.current != null) {
              sendMessage(imChatLaterMessageRef.current.content);
              imChatLaterMessageRef.current = null;
            }
          }, 2000);
          // 判断是否存在消息
          messageList = e.data.message ? JSON.parse(e.data.message) : [];
        }

        // 如果socket返回的状态是action_1001（已存在会话）
        if (e.message === IMWebClient.config.sessionAction.action_1001) {
          successChatCountRef.current = successChatCountRef.current * 1 + 1;
          // let sessionId = IMWebClient.session.sessionId || localStorage.getItem('imChatSessionId');
          // IMWebClient.waitCustomerCount(chatConfig.companyId, sessionId).then((res) => {
          //   if (res.code === 200) {
          //     // let waitCount = res.data && res.data > 0 ? res.data - 1 : 0;
          //     let waitCount = res.data || 0;
          //     let content = chatConfig.waitInLineBefore + ' ' + waitCount + ' ' + chatConfig.waitInLineLater;
          //     console.log('messageList>>>', messageList);
          //     let message = createMessageItem({
          //       dataType: messageDateType.EVENT,
          //       content: content,
          //       sessionId: sessionId,
          //       contentType: 'queueCount',
          //     });
          //     addMessageItem(message);
          //   }
          // });
          // 判断是否存在消息
          // messageList = e.data.message ? JSON.parse(e.data.message) : [];

          await findMessageDataItem(chatConfig.channelId, messageIdRef.current).then((res) => {
            if (res) {
              if (res.list?.length > 0) {
                console.log('1001存在未接收的消息messageList>>>', res.list);
                setMessageList(res.list);
                messageListRef.current = res.list;
              }
              // messageListRef.current = res.list;
            }
          });
        }

        // 如果socket返回的状态是action_1005（通话断开ACW）和action_1006（通话结束）
        if (
          e.message === IMWebClient.config.sessionAction.action_1005 ||
          e.message === IMWebClient.config.sessionAction.action_1006
        ) {
          IMWebClient.disconnect({ tenantId: chatConfig.companyId }); // 执行IM挂断
        }
        setTimeout(() => {
          setInputDisable(false);
        }, 1000);
        return;
      }
      // 绑定失败回调，存在参数错误和服务端的数据错误时进入
      if (e.key === IMWebClient.config.KEY_CLIENT_BIND && e.code !== IMWebClient.config.CODE_OK) {
        // 关闭人工渠道并打开人工评分。
        setEvaluationState(true);
        IMWebClient.stop();
        return;
      }
      // 连接断开成功回调
      if (e.key === IMWebClient.config.KEY_CLIENT_CLOSED && e.code === IMWebClient.config.CODE_OK) {
        console.log('连接断开成功回调');
        await findMessageDataItem(chatConfig.channelId, messageIdRef.current).then((res) => {
          if (res) {
            if (res.list?.length > 0) {
              console.log('handleIMChatConnectClosed存在未接收的消息messageList>>>', res.list);
              setMessageList(res.list);
              messageListRef.current = res.list;
            }
            // messageListRef.current = res.list;
          }
          cacheHistorySession('isDisconnect', true); // 更新缓存中的聊天断开状态
          localStorage.removeItem('inProgress');
        });
        // let message = createMessageItem({
        //   dataType: messageDateType.EVENT,
        //   content: chatConfig.endChatMessage,
        //   contentType: 'endChat',
        //   msgId: e.data.contentId,
        // });
        // addMessageItem(message);
        return;
      }
      // 客服已读消息回调
      if (e.key === IMWebClient.config.KEY_CLIENT_MESSAGE_READ && e.code === IMWebClient.config.CODE_OK) {
        console.log('客服已读消息回调');
        setMessageList((prevList) => {
          let arr = prevList.map((message) =>
            message.role === 'CUSTOMER' ? { ...message, messageAckStatus: 'READ' } : message
          );
          messageListRef.current = [...arr];
          return arr;
        });
        return;
      }

      // 连接断开失败回调，存在参数错误和服务端的数据错误时进入
      if (e.key === IMWebClient.config.KEY_CLIENT_CLOSED && e.code !== IMWebClient.config.CODE_OK) {
        console.log('socket断开失败', e.message);
        IMWebClient.stop();
        return;
      }
      // 客服接听回调
      if (e.key === IMWebClient.config.KEY_CLIENT_CALL && e.code === IMWebClient.config.CODE_OK) {
        if (e.data?.profilePicturePath) {
          let avatarList = localStorage.getItem('imChatAvatar');
          if (avatarList) {
            avatarList = JSON.parse(avatarList);
          } else {
            avatarList = [];
          }
          let isExist = avatarList.findIndex((item) => item.uid === e.data.uid);
          if (isExist === -1) {
            avatarList.push({
              avatar: e.data.profilePicturePath,
              uid: e.data.uid,
              userName: e.data.username,
            });
          } else {
            avatarList[isExist].avatar = e.data.profilePicturePath;
          }
          localStorage.setItem('imChatAvatar', JSON.stringify(avatarList));
        }
        IMWebClient.session.sessionId = e.data.sessionId;
        // 缓存IM连接上服务后返回的数据
        updateCacheProperty('imChatSessionId', e.data.sessionId);
        localStorage.setItem('imChatSessionId', e.data.sessionId);

        setEvaluationState(true); // 有客服接听，开启通话结束后评分功能
        let ts = new Date().getTime();
        reciveMessageTime.current = ts;
        addMessageItem(
          createMessageItem({
            dataType: messageDateType.DIVIDER,
            content: formatTime(ts),
            isNotUse: true,
            isNotCurrentSessionData: true,
          })
        );
        if (chatConfig.pushSystemMessageFlag != '0') {
          let message = createMessageItem({
            dataType: messageDateType.EVENT,
            content: e.data.username + ' ' + chatConfig.joinChatMessage,
            contentType: 'agentJoin',
            msgId: e.data.contentId,
            channel: channelState.IM_CHAT,
          });
          addMessageItem(message);
        }
        return;
      }
      // 消息已读回调
      if (e.key === IMWebClient.config.KEY_CLIENT_MESSAGE_READ && e.code === IMWebClient.config.CODE_OK) {
        // 将messageList数据都改为已读。
        setMessageList((prevList) => {
          let arr = prevList.map((message) =>
            message.role === IMWebClient.config.role ? { ...message, messageStatus: chatConfig.messageRead } : message
          );
          messageListRef.current = [...arr];
          return arr;
        });
        return;
      }
      // 系统消息回调，根据类型做对应处理
      if (e.key === IMWebClient.config.KEY_CLIENT_SYSTEM_EVENT && e.code === IMWebClient.config.CODE_OK) {
        let inProgress = JSON.parse(localStorage.getItem('inProgress'));
        addEvaluationItem(messageIdRef.current, sessionId, inProgress.imChatUid);
        return;
      }
      //切换用户状态
      if (e.key === IMWebClient.config.KEY_CLIENT_CHANGE_STATUS && e.code === IMWebClient.config.CODE_OK) {
        console.log('拉取离线消息');
        await findMessageDataItem(chatConfig.channelId, messageIdRef.current).then((res) => {
          if (res) {
            let messageList = res.list;
            if (messageList?.length > 0) {
              console.log('存在未接收的消息messageList>>>', messageList);
              setMessageList(messageList);
              messageListRef.current = messageList;
            }
            // messageListRef.current = res.list;
          }
        });
        // 判断是否存在未接受到的消息
      }
      // 正在输入
      if (e.key === IMWebClient.config.BE_INPUTING && e.code === IMWebClient.config.CODE_OK) {
        console.log('正在输入');
        if (!agentInput) {
          setAgentInput(true);
          setTimeout(() => {
            setAgentInput(false);
          }, 3000);
        }
      }
      // 撤回消息处理
      if (e.key === IMWebClient.config.MESSAGE_WITHDRAW && e.code === IMWebClient.config.CODE_OK) {
        console.log('消息撤回', e);
        let data = e.data;
        let messageId = data.contentId;
        console.log(messageId);
        let message = createMessageItem({
          dataType: messageDateType.EVENT,
          content: chatConfig.recallMsg,
          msgId: e.data.contentId,
          channel: channelState.IM_CHAT,
        });
        setMessageList((prevList) => {
          let arr = prevList.map((item) => (item.msgId === messageId ? message : item));
          messageListRef.current = [...arr];
          return arr;
        });
        setMessageList((prevList) => {
          let updatedList = [...prevList];
          updatedList.forEach((item) => {
            console.log(item);
            if (item?.extra?.referenceMessage?.referenceContentId === messageId) {
              item.extra.referenceMessage.referenceContent = chatConfig.isRecallMsg;
              item.extra.referenceMessage.referenceContentType = 'text';
              item.extra.referenceMessage.referenceReplyPerson = '';
            }
          });
          messageListRef.current = [...updatedList];
          return updatedList;
        });
      }

      // 转派消息回调
      if (e.key === IMWebClient.config.KEY_CLIENT_REASSIGN && e.code === IMWebClient.config.CODE_OK) {
        let originalAgentName = e.data.originalAgentName;
        let toAgentName = e.data.username;
        IMWebClient.session.sessionId = e.data.sessionId;
        sessionId = e.data.sessionId; // 记录转单的工单会话ID，发送满意度评分时使用
        // 缓存IM连接上服务后返回的数据
        updateCacheProperty('imChatSessionId', e.data.sessionId);
        localStorage.setItem('imChatSessionId', e.data.sessionId);
        let content = '';
        // 如果转派类型是退出
        if (e.data.type === 'quit') {
          content = e.data.originalAgentName + ' ' + chatConfig.endChatMessage;
        }
        // 如果转派类型是加入
        else if (e.data.type === 'join') {
          content = chatConfig.reassignJoin || '您的咨询已由坐席 {agent1_name} 转接至坐席 {agent2_name}';
          content = content.replace('{agent1_name}', originalAgentName);
          content = content.replace('{agent2_name}', toAgentName);
        }
        let message = createMessageItem({
          dataType: messageDateType.EVENT,
          content: content,
          contentType: 'agentJoin',
          msgId: e.data.contentId,
          channel: channelState.IM_CHAT,
        });
        addMessageItem(message);
        return;
      } else if (e.key === IMWebClient.config.CLIENT_NO_AVAILABLE_AGENT && e.code === IMWebClient.config.CODE_OK) {
        addEventItem(chatConfig.noAvailableAgent);
        return;
      }
    }
    // 普通消息
    if (type === 'message') {
      playTipAudio();
      setEvaluationState(true);
      let extra = {};
      if (e.extra) {
        extra = JSON.parse(e.extra);
      }
      if (new Date().getTime() - reciveMessageTime.current >= messageWaitTime * 60 * 1000) {
        reciveMessageTime.current = new Date().getTime();
        addMessageItem(
          createMessageItem({
            dataType: messageDateType.DIVIDER,
            content: formatTime(new Date().getTime()),
            isNotUse: true,
            isNotCurrentSessionData: true,
          })
        );
      }

      const message = createMessageItem({
        dataType: messageDateType.MESSAGE,
        role: messageRole.AGENT,
        contentType: e.format,
        content: e.content,
        displayName: e.username || '',
        fileName: extra.attachmentName || '',
        ticketAttr: chatConfig.ticketAttr,
        msgId: e.id,
        extra: JSON.parse(e.extra),
        uid: e.sender || '',
        channel: channelState.IM_CHAT,
      });
      addMessageItem(message);
      // 如果窗口开启状态发送已读消息
      if (isPageVisible && toggleIcon && container === containerState.CHAT_WIDGET) {
        handleSendMessageRead(e.role);
      }
    }
  }

  /**
   * 处理发送IM消息
   * @param content
   * @param contentType
   * @param fileName
   */
  function handleSendIMMessage(content, contentType, fileName, duration) {
    let params = {
      contentType: contentType || 'markdown',
      content: content,
      attachmentName: fileName,
      tenantId: chatConfig.companyId,
      ticketAttr: chatConfig.ticketAttr,
    };
    if (contentType == 'image' || contentType == 'video' || contentType == 'link') {
      params.workRecordFileList = [
        {
          fileName: fileName,
          fileUrl: content,
          bucketName: content.split('/')[2].split('.')[0],
        },
      ];
    }
    IMWebClient.send(params);
    let message = createMessageItem({
      dataType: messageDateType.MESSAGE,
      role: messageRole.CUSTOMER,
      displayName: customerName,
      contentType: contentType || 'text/plain',
      content: content,
      fileName: fileName,
      ticketAttr: chatConfig.ticketAttr,
      duration: duration,
    });
    if (contentType !== 'text' || contentType !== 'text/plain' || contentType !== 'markdown') {
      message.uploadProgress = 100;
      message.uploadStatus = 'none';
    }
    addMessageItem(message);
  }

  /**
   * 处理发送IM消息已读消息
   */
  function handleSendMessageRead(role) {
    IMWebClient.read({ tenantId: chatConfig.companyId, sendMessageRole: role });
  }

  // ============================================================================== 组件使用函数
  /**
   * 处理输入框发送消息
   * @param content
   * @param contentType
   * @param fileName //‘’
   * @param knowledge //消息传false
   * @param uploadProgress
   * @param uploadStatus
   * @returns id
   */
  const sendMessage = useCallback(
    async (
      content,
      contentType,
      fileName,
      knowledge = true,
      uploadProgress = 100,
      uploadStatus = 'none',
      duration = '',
      faqId = ''
      // initChannel
    ) => {
      // debugger;
      userTime = new Date().getTime();
      // console.log('发送消息》〉》', content);
      // console.log('chatOpenChannelType>>>', channel);
      // console.log('chatOpenChannelType>>>', initChannel);
      // if (!agentDisabled) {
      //   sendDelayMessage(2);
      // }
      if (content === '' && contentType != 'audio') return;
      let time = new Date().getTime();
      if (time - reciveMessageTime.current >= messageWaitTime * 60 * 1000) {
        reciveMessageTime.current = time;
        addMessageItem(
          createMessageItem({
            dataType: messageDateType.DIVIDER,
            content: formatTime(time),
            isNotUse: true,
            isNotCurrentSessionData: true,
          })
        );
      }
      let chatOpenChannelType = chatConfig.chatOpenChannelType;
      const messageId = generateUUID();
      const message = createMessageItem({
        dataType: messageDateType.MESSAGE,
        role: messageRole.CUSTOMER,
        displayName: customerName,
        contentType: contentType || 'text/plain',
        content: content,
        fileName: fileName,
        uploadProgress: uploadProgress,
        uploadStatus: uploadStatus,
        messageId: messageId,
        duration: duration,
        faqId: faqId,
        ticketAttr: chatConfig.ticketAttr,
      });
      if (contentType === 'audio' && content == '') {
        addMessageItem(message);
      } else {
        // 判断开启的渠道
        if ('1' === chatOpenChannelType || '3' === chatOpenChannelType) {
          if (channelState.KNOWLEDGE === channel && content != '') {
            // 判断是否存在转人工关键字
            // if (content && content != '' && '1' === chatConfig.chatKnowledgeUnknownTransferAgent) {
            if (content && content != '') {
              let strArr = chatConfig.menuToAgentTxt.split(',');
              const result = isContentInArray(content, strArr);
              // 如果消息内容包含在转人工关键字列表中
              if (result) {
                knowledge = false;
                // todo 判断执行那个人工渠道
                // loadConnectChannel();
                // loadIMChatChannel();
                /*if (channelState.CONNECT === channel) {
                  loadConnectChannel();
                } else if (channelState.IM_CHAT === channel) {
                  loadIMChatChannel();
                } else {
                  console.log('没有人工渠道');
                }*/
                // 判断是否未转人工
                if (agentDisabled) {
                  // 德业公司需求非工作时间不转人工
                  if (
                    chatConfig.companyId === '7f7113da58b91751b7336213542d9232' ||
                    chatConfig.companyId === '03f433505c9cdfb7d56afc32127f1d85'
                  ) {
                    let r = await checkWorkingHoursFunc();
                    if (!r) {
                      addMessageItem(message);
                      // 如果不再工作时间发送一条非工作时间的系统消息。
                      addEventItem(chatConfig.nonWorkingHours);
                    } else if (chatConfig.openSelfChat === '1') {
                      loadIMChatChannel();
                    }
                  } else {
                    //除德业外所有人工时间处理
                    let form = JSON.parse(localStorage.getItem('goclouds-chat-form'));
                    let userName = (form ? form.username : '') || chatConfig.username;
                    let phoneNumber = (form ? form.phoneNumber : '') || '';
                    let params = {
                      channelId: chatConfig.channelId,
                      chatUserName: userName,
                      ticketId: sessionId,
                      customerContactInfo: phoneNumber,
                    };
                    params = sortObjectKeysLexicographically(params);
                    let ts = new Date().getTime();
                    let sign =
                      'client_id=' +
                      process.env.CLIENT_ID +
                      '&ts=' +
                      ts +
                      '&body=' +
                      JSON.stringify(params) +
                      '&client_secret=' +
                      process.env.SECURITY_KEY;
                    let header = {
                      ts: ts,
                      sign: CryptoJS.MD5(sign.toLocaleLowerCase()).toString(CryptoJS.enc.Hex),
                    };
                    checkWorkTime(params, header).then((res) => {
                      addMessageItem(true);
                      if (res?.code == 200 && chatConfig.openSelfChat === '1' && res?.data == 1) {
                        loadIMChatChannel();
                      } else if (res?.code == 200 && res?.data == 0) {
                        addEventItem(chatConfig.notWorkTime);
                      } else {
                        console.log('没有人工渠道');
                      }
                    });
                  }
                }
              }
            }
            // console.log('knowledge>>>', knowledge);
            sendKnowledgeMessage(message, knowledge);
          }

          // if (channelState.CONNECT === channel) {
          //   // console.log('CONNECT');
          //   if (uploadStatus === 'none') {
          //     sendConnectMessage(content, contentType, fileName);
          //   } else {
          //     addMessageItem(message);
          //   }
          // }

          if (channelState.IM_CHAT === channel || channelState.CONNECT === channel) {
            let inProgress = JSON.parse(localStorage.getItem('inProgress'));
            console.log('inProgress>>>', inProgress);
            if (!inProgress || !inProgress?.imChatSessionId) {
              setInputDisable(true);
              imChatLaterMessageRef.current = message;
              loadChatChannel(chatConfig.chatOpenChannelType == 1 ? 'KNOWLEDGE' : channelState.IM_CHAT);
              return;
            }
            // console.log('IM_CHAT');
            // console.log('uploadStatus>>>', uploadStatus);
            if (uploadStatus === 'none') {
              // console.log(uploadStatus);
              if (contentType == 'audio') {
                handleSendIMMessage(content, 'text', '', duration);
              } else {
                handleSendIMMessage(content, contentType, fileName);
              }
            } else {
              addMessageItem(message);
            }
          }
        } else if ('2' === chatOpenChannelType) {
          sendKnowledgeMessage(message, knowledge);
        } else {
          addEventItem('缺少渠道配置，请稍后再试或联系管理员');
        }
      }
      return messageId;
    },
    [channel]
  );
  /**
   * 延迟发送消息
   * @param type
   * 1: 机器人发送消息
   */
  function sendDelayMessage(type) {
    // 清除之前的定时器
    timerRef.current.forEach((timer) => clearTimeout(timer));
    timerRef.current = [];
    getReminder({ companyId: chatConfig.companyId, language: chatConfig.language }).then((res) => {
      console.log('res', res);
      const messageRemindingList = res.data.messageRemindingList || [];
      const messages =
        messageRemindingList && messageRemindingList.length > 0
          ? messageRemindingList.filter((item) => item.messageType === type)
          : [];
      // 计算累计时间并设置定时器
      messages.forEach((message, index) => {
        let accumulatedTime = message.waitTimeSeconds * 1000; // 转换为毫秒
        const timer = setTimeout(() => {
          addMessageItem({
            dataType: messageDateType.MESSAGE,
            role: messageRole.AGENT,
            displayName: chatConfig.botName,
            contentType: 'text/plain',
            content: message.message,
          });
        }, accumulatedTime);

        timerRef.current.push(timer);
      });
    });
  }
  /**
   * 点击消息的文字按钮
   */
  const handleClickMessage = async (item) => {
    if (isHistory) {
      return;
    }
    // 如果开启了未知回复转人工 并且 点击了转人工按钮
    if ('1' === chatConfig.chatKnowledgeUnknownTransferAgent && item.name === chatConfig.menuToAgentTxt.split(',')[0]) {
      // 判断是否已经转人工
      if (!agentDisabled) {
        return;
      }

      // 德业公司需求非工作时间不转人工
      if (
        chatConfig.companyId === '7f7113da58b91751b7336213542d9232' ||
        chatConfig.companyId === '03f433505c9cdfb7d56afc32127f1d85'
      ) {
        let r = await checkWorkingHoursFunc();
        if (!r) {
          // 如果不再工作时间发送一条非工作时间的系统消息。
          addEventItem(chatConfig.nonWorkingHours);
          return;
        }
      }

      const message = createMessageItem({
        dataType: messageDateType.MESSAGE,
        role: messageRole.CUSTOMER,
        displayName: customerName,
        contentType: 'text/plain',
        content: item.name || item.content,
      });
      addMessageItem(message);
      // todo 判断执行那个人工渠道
      // loadConnectChannel();
      // loadIMChatChannel();
      /*if (channelState.CONNECT === channel) {
        loadConnectChannel();
      } else if (channelState.IM_CHAT === channel) {
        loadIMChatChannel();
      } else {
        console.log('没有人工渠道');
      }*/
      if (chatConfig.openSelfChat === '0') {
        loadConnectChannel();
      } else if (chatConfig.openSelfChat === '1') {
        loadIMChatChannel();
        console.log(1234);
      } else {
        console.log('没有人工渠道');
      }
    } else {
      // 发送消息并请求知识库回复
      const message = createMessageItem({
        dataType: messageDateType.MESSAGE,
        role: messageRole.CUSTOMER,
        displayName: customerName,
        contentType: 'text/plain',
        content: item.name || item.content,
        qid: item.id || '',
        faqId: item.id || '',
        ticketAttr: chatConfig.ticketAttr,
      });
      sendKnowledgeMessage(message, true);
    }
  };
  /**
   * 点击结束聊天按钮
   */
  let inEnd = false;
  const handleClickEndChat = async () => {
    if (inEnd) return;
    inEnd = true;
    // 如果是机器人
    if (channel === channelState.KNOWLEDGE) {
      cacheHistorySession('isDisconnect', true); // 更新缓存中的聊天断开状态
      handleClickCloseChat(); // 关闭窗口
      return;
    }
    // 如果是CONNECT人工
    if (channel === channelState.CONNECT) {
      handleClickCloseChat(); // 关闭窗口
      if (chatSession) {
        try {
          await chatSession.disconnectParticipant();
        } catch (e) {
          handleConnectEnded();
        }
      }
      return;
    }
    // 如果是IM_CHAT人工
    if (channel === channelState.IM_CHAT) {
      // handleClickCloseChat(); // 关闭窗口
      let inProgress = JSON.parse(localStorage.getItem('inProgress'));
      if (!inProgress.imChatSessionId) {
        IMWebClient.stop();
      } else {
        IMWebClient.disconnect({ tenantId: chatConfig.companyId }); // 执行IM挂断
      }
      inEnd = false;
    }
    if (onEndChat) {
      onEndChat();
    }
  };
  window.forNativeEndChat = handleClickEndChat;
  /**
   * 处理点击底部操作区域返回按钮
   */
  const handleClickBackContact = () => {
    setMessageDataId('');
    messageIdRef.current = '';
    setIsHistory(false);
    setContainer(containerState.CONTACT);
  };
  /**
   * 处理点击关闭按钮
   */
  const handleClickCloseChat = () => {
    // 关闭窗口
    if (device === 'pc') {
      setToggleIcon(false);
    }
    // 移除inProgress缓存值
    localStorage.removeItem('inProgress');
    // 设置初始聊天状态
    setChatting(false); // 初始聊天中状态
    setDisconnect(true); // 初始聊天挂断状态
    setOperationState(false); // 初始操作部分状态
    setEvaluationState(false); // 初始评分状态
    setMessageList([]); // 清空消息列表
    messageListRef.current = [];
    setMessageDataId(''); // 清空消息数据id
    messageIdRef.current = '';
    sessionId = ''; // 清空机器人回话id
    setLoading(true); // 初始容器的加载状态
    setContainer(containerState.CONTACT);
    setChannel(channelState.KNOWLEDGE);
  };
  /**
   * 处理点击评分
   * @param value 数值
   */
  const handleClickRate = (value, message) => {
    console.log('handleClickRate>>', value, message);
    // 评价的消息数据已发生变化，重新执行渲染数据。
    let historySession = JSON.parse(localStorage.getItem('historySession')) || [];
    let foundChannel = historySession.find((channel) => channel.channelId === chatConfig.channelId);
    let historyMessages = foundChannel.list;
    historyMessages.forEach((item) => {
      item.list.forEach((item1) => {
        if (item1.messageDataId === message.messageDataId) {
          item1.disabled = true;
          item1.content = value;
        }
      });
    });
    localStorage.setItem('historySession', JSON.stringify(historySession));
    setMessageList((preCustomerList) => {
      const newList = [...preCustomerList];
      messageListRef.current = newList;
      return newList;
    });
    // 评分人
    let commentUser = formData['chat_email'] || customerName;
    // 获取联系id
    let contactId = getContactId();
    // 工单id
    let workRecordId = message.workRecordId;

    let params = {
      companyId: chatConfig.companyId,
      score: value,
      commentUser: commentUser,
    };

    // 如果存在联系id
    if (contactId) {
      params.contactId = contactId;
    }
    // 如果存在工单id
    if (workRecordId) {
      params.workRecordId = workRecordId;
    }
    let uid = message.imChatUid;
    if (uid) {
      try {
        // 执行请求满意度评价接口
        IMWebClient.Rate({
          uid: uid,
          starCount: value + '',
        });
      } catch (error) {
        console.log('error', error);
      }
    }
    // 执行请求满意度评价接口
    chatCsatScore(params).then((res) => {});

    /*let contactId = sessionId || getContactId(); // 工单id
    if (contactId !== undefined && contactId !== null && contactId !== '') {
      if (contactId) {
        let commentUser = formData['chat_email'] || customerName;
        let params = {
          contactId: contactId,
          workRecordId: contactId,
          companyId: chatConfig.companyId,
          score: value,
          commentUser: commentUser,
        };
        // 执行请求满意度评价接口
        chatCsatScore(params).then((res) => {});
      }
    }*/
  };
  /**
   * 处理打开视频
   * @param value
   */
  const handleOpenVideo = (value) => {
    setContainer(value);
  };
  /**
   * 处理连接视频电话了，关闭聊天。
   */
  const handleEndChatSession = async () => {
    // 开启评分
    setEvaluationState(true);
    if (chatSession) {
      await chatSession.disconnectParticipant();
    }
    setChannel(channelState.KNOWLEDGE);
  };
  /**
   * 已接通的视频关闭后，回调事件
   */
  const handleEndVideo = () => {
    // 查询消息列表是否存在评分消息
    const evaluation = messageList.find((f) => f.dataType === messageDateType.EVALUATION);
    if (!evaluation) {
      setOperationState(true); // 开启关闭窗口模块
      addEvaluationItem(); // 发送评分消息
    }

    // 更新缓存中的聊天断开状态
    cacheHistorySession('isDisconnect', true);
    setChatting(true);
    setChannel(channelState.KNOWLEDGE);
    setVideoCallState(true);
  };

  /**
   * 处理点击引导问题
   * @param item
   */
  const handleClickGuideQuestion = (item) => {
    // 如果输入框没有禁用，则可以发送引导问题
    if (!inputDisable) {
      sendMessage(item.content, 'text/plain');
    }
  };

  const handleClickLikeBut = async (item, status) => {
    // 判断是否点击过
    if (null !== item.likeStatus) {
      return;
    }
    // 发送消息
    setMessageList((prevList) => {
      let arr = prevList.map((message) =>
        message.messageId === item.messageId ? { ...message, likeStatus: status } : message
      );
      messageListRef.current = [...arr];
      return arr;
    });
    let msgId = item.answerId;
    if (msgId) {
      await upvoteOrDownvote({ msgId: msgId, status: status, companyId: chatConfig.companyId });
    }
  };

  // 德业需求非工作时间不转人工
  async function checkWorkingHoursFunc() {
    // 通过请求chat后端接口传递公司id返回是否在工作时间。true在工作时间，false不再工作时间
    let result = false;

    let r = await checkWorkingHours({ companyId: chatConfig.companyId });
    if (r.code === 200) {
      if (r.data) {
        result = r.data;
      }
    }
    return result;
  }
  const hexToRgb = (hex) => {
    // 去除可能存在的 # 符号
    hex = hex.replace('#', '');

    // 检查十六进制代码是否为 3 位或 6 位
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }

    // 解析十六进制值为十进制
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);

    return `${r}, ${g}, ${b}`;
  };
  return (
    <ChatBodyContainer
      className="animate__animated animate__slideInRight"
      style={{ height: chatConfig.noHeader && device === 'mobile' ? '100%' : 'calc(100% - 40px)' }}
    >
      {container === containerState.CHAT_WIDGET ? (
        <ChatBodyWrapper $zoomwindow={zoomWindowStrState} $device={device}>
          <ChatBodyMessageContainer id="messageContainer">
            <ChatMessage
              device={device}
              chatConfig={chatConfig}
              messageList={messageList}
              handleClickMessage={handleClickMessage}
              handleClickRate={handleClickRate}
              uploadCancelToken={uploadCancelToken}
              updateMessageScrollBarInfo={updateMessageScrollBarInfo}
              handleClickLikeBut={handleClickLikeBut}
            />
          </ChatBodyMessageContainer>

          {device === 'pc' ? (
            <ChatBodyOperationContainer $operationState={operationState}>
              {inputDisable && channel !== channelState.IM_CHAT ? (
                <LoadingTextBox $chatservicecolor={chatConfig.chatServiceColor}>
                  <div>{chatConfig.botBeReplyingMsg}</div>
                </LoadingTextBox>
              ) : (
                ''
              )}
              {/* {inputDisable && channel === channelState.IM_CHAT ? (
                <LoadingTextBox $chatservicecolor={chatConfig.chatServiceColor}>
                  <div>{inStream ? chatConfig.botBeReplyingMsg : chatConfig.retryInfo}</div>
                </LoadingTextBox>
              ) : (
                ''
              )} */}
              {!operationState &&
              channelState.KNOWLEDGE === channel &&
              chatConfig.guideQuestion &&
              chatConfig.guideQuestion.length > 0 ? (
                <GuideQuestionContainer>
                  <GuideQuestionTitle>
                    {chatConfig.languageCode.includes('zh') ? '您可以这样问：' : 'You can ask like this：'}
                  </GuideQuestionTitle>
                  <Carousel
                    adaptiveHeight={true}
                    dotPosition="left"
                    arrows={false}
                    dots={false}
                    autoplay={true}
                    autoplaySpeed={2000}
                    infinite={true}
                  >
                    {chatConfig.guideQuestion.map((item) => (
                      <CarouselItemWrapper>
                        <CarouselItem onClick={() => handleClickGuideQuestion(item)}>{item.content}</CarouselItem>
                      </CarouselItemWrapper>
                    ))}
                  </Carousel>
                </GuideQuestionContainer>
              ) : (
                ''
              )}

              {!operationState ? (
                <ChatBodyInputContainer>
                  {chatButtonList && chatButtonList.length > 0 && (
                    <ChatButton $themecolor={hexToRgb(chatConfig.chatThemeColor)}>
                      {chatButtonList?.map((item) => (
                        <ChatButtonItem
                          key={'questionId' + item.questionId}
                          $themecolor={hexToRgb(chatConfig.chatThemeColor)}
                          onClick={() => handleClickMessage({ content: item.content })}
                        >
                          {item.buttonName}
                        </ChatButtonItem>
                      ))}
                    </ChatButton>
                  )}
                  <Editor
                    setFileSizeErrorModal={setFileSizeErrorModal}
                    IMWebClient={IMWebClient}
                    $zoomwindow={zoomWindowStrState}
                    inputDisable={inputDisable}
                    sendMessage={sendMessage}
                    setUploadProgress={setUploadProgress}
                    setUploadCancelToken={setUploadCancelToken}
                    chatConfig={chatConfig}
                    updateMessageById={updateMessageById}
                    container={container}
                    isHistory={isHistory}
                    handleClickToAgent={handleClickToAgent}
                    agentDisabled={agentDisabled}
                  />
                </ChatBodyInputContainer>
              ) : (
                ''
              )}
              {!operationState && !chatConfig.singleChat ? (
                <ChatBodyButtonContainer>
                  <EndButton onClick={() => handleClickEndChat()}>{chatConfig.endOfConversation}</EndButton>
                  {chatConfig.chatOpenChannelType !== '2' &&
                  chatConfig.openAudio === '1' &&
                  chatConfig.showOnlineMediaForVIP ? (
                    <VideoButton
                      $themecolor={chatConfig.chatThemeColor}
                      onClick={() => handleOpenVideo(containerState.VIDEO)}
                    >
                      <img alt="" src={videoBtn} style={{ marginRight: '5px' }} />
                      {chatConfig.openVideoButton}
                    </VideoButton>
                  ) : (
                    ''
                  )}
                </ChatBodyButtonContainer>
              ) : (
                ''
              )}
              {operationState && !chatConfig.isVideoContainer ? (
                <ChatBodyEndContainer>
                  {evaluationState && chatConfig.chatSatisfactionEvaluationFlag === '1' ? (
                    <EvaluationIcon>
                      <img src={face} alt="" />
                    </EvaluationIcon>
                  ) : (
                    ''
                  )}
                  {evaluationState && chatConfig.chatSatisfactionEvaluationFlag === '1' ? (
                    <EvaluationText>{chatConfig.satisfactionEvaluationTips}</EvaluationText>
                  ) : (
                    ''
                  )}
                  {isHistory ? (
                    <EvaluationButton onClick={handleClickBackContact} $themecolor={chatConfig.chatThemeColor}>
                      {chatConfig.historyMsgBack}
                    </EvaluationButton>
                  ) : (
                    <EvaluationButton onClick={handleClickCloseChat} $themecolor={chatConfig.chatThemeColor}>
                      {chatConfig.closeChatButton}
                    </EvaluationButton>
                  )}
                </ChatBodyEndContainer>
              ) : (
                ''
              )}
            </ChatBodyOperationContainer>
          ) : (
            ''
          )}
          {device === 'mobile' ? (
            <ChatBodyOperationContainer $operationState={operationState}>
              {inputDisable && channel !== channelState.IM_CHAT ? (
                <LoadingTextBox $chatservicecolor={chatConfig.chatServiceColor}>
                  <div>{chatConfig.botBeReplyingMsg}</div>
                </LoadingTextBox>
              ) : (
                ''
              )}
              {inputDisable && channel === channelState.IM_CHAT && !isEndChat && successChatCountRef.current > 2 ? (
                <LoadingTextBox $chatservicecolor={chatConfig.chatServiceColor}>
                  <div>{chatConfig.retryInfo}</div>
                </LoadingTextBox>
              ) : (
                ''
              )}
              {!operationState ? (
                <div>
                  {chatButtonList && chatButtonList.length > 0 && (
                    <ChatButton $device="mobile" $themecolor={hexToRgb(chatConfig.chatThemeColor)}>
                      {chatButtonList?.map((item) => (
                        <ChatButtonItem
                          $device="mobile"
                          key={'questionId' + item.questionId}
                          $themecolor={hexToRgb(chatConfig.chatThemeColor)}
                          onClick={() => {
                            if (!inputDisable) {
                              handleClickMessage({ content: item.content });
                            }
                          }}
                        >
                          {item.buttonName}
                        </ChatButtonItem>
                      ))}
                    </ChatButton>
                  )}
                  <ChatMobileInput
                    setFileSizeErrorModal={setFileSizeErrorModal}
                    agentDisabled={agentDisabled}
                    channel={channel}
                    inputDisable={inputDisable}
                    sendMessage={sendMessage}
                    handleOpenVideo={handleOpenVideo}
                    chatConfig={chatConfig}
                    setUploadProgress={setUploadProgress}
                    setUploadCancelToken={setUploadCancelToken}
                    updateMessageById={updateMessageById}
                    setMobileAgentDisabled={setMobileAgentDisabled}
                  />
                </div>
              ) : (
                ''
              )}
              {operationState && !chatConfig.isVideoContainer ? (
                <ChatBodyEndContainer $device={device}>
                  {evaluationState && chatConfig.chatSatisfactionEvaluationFlag === '1' ? (
                    <EvaluationIcon>
                      <img src={face} alt="" />
                    </EvaluationIcon>
                  ) : (
                    ''
                  )}
                  {evaluationState && chatConfig.chatSatisfactionEvaluationFlag === '1' ? (
                    <EvaluationText>{chatConfig.satisfactionEvaluationTips}</EvaluationText>
                  ) : (
                    ''
                  )}
                  {isHistory ? (
                    <EvaluationButton onClick={handleClickBackContact} $themecolor={chatConfig.chatThemeColor}>
                      {chatConfig.historyMsgBack}
                    </EvaluationButton>
                  ) : (
                    <EvaluationButton onClick={handleClickCloseChat} $themecolor={chatConfig.chatThemeColor}>
                      {chatConfig.closeChatButton}
                    </EvaluationButton>
                  )}
                </ChatBodyEndContainer>
              ) : (
                ''
              )}
            </ChatBodyOperationContainer>
          ) : (
            ''
          )}
        </ChatBodyWrapper>
      ) : container === containerState.VIDEO ? (
        <WrappedMeetingPage
          chatConfig={chatConfig}
          initiateChatRequest={initiateChatRequest}
          handleOpenVideo={(flag) => handleOpenVideo(flag)}
          device={device}
          handleEndChatSession={handleEndChatSession}
          setEvaluationState={setEvaluationState}
          handleEndVideo={handleEndVideo}
          setContactId={setContactId}
        />
      ) : (
        ''
      )}
      {loading && <Spinner chatThemeColor={chatConfig.chatThemeColor} />}
      {error && <Spinner error={error} />}
      {/* 文件大于200mb提醒 */}
      {fileSizeErrorModal && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.5)',
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 'calc(100% - 60px)',
              padding: '20px',
              // height: '',
              background: '#fff',
              borderRadius: '10px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
              <ErrorIcon />
              <p style={{ color: '#333', margin: '10px 0' }}>
                {chatConfig.fileSizeErrorText || '无法上传超过200MB的文件'}
              </p>
            </div>
            <div
              onClick={() => setFileSizeErrorModal(false)}
              style={{
                width: '100%',
                textAlign: 'center',
                background: '#F0F0F0',
                color: '#333',
                padding: '10px 0',
                borderRadius: '20px',
                cursor: 'pointer',
              }}
            >
              {chatConfig.fileSizeErrorButton || '我知道了'}
            </div>
          </div>
        </div>
      )}
    </ChatBodyContainer>
  );
});

export default ChatBody;
